/*
 * @Author: AI Assistant
 * @Date: 2025-12-10
 * @Description: SEO内容模块多语言配置
 * @FilePath: /weryai-web/locales/modules/seoContent.ts
 */
export default {
    zh: {
        // 按钮
        expandMore: '展开更多内容',
        collapse: '收起',

        // 第一部分：标题介绍
        mainTitle: '免费的一站式 AI 视频与图片生成平台',
        mainDesc1:
            '在一个地方访问全球顶级 AI 模型。用 Kling AI、Google Veo 与 Sora 生成电影感视频，用 FLUX 与 Wan AI 创作逼真艺术作品，或使用换脸、视频超分等高级工具。无需来回切换应用——专注创作即可。',
        mainDesc2: '使用最快速、最直观的 AI 创作平台，即刻创建专业视频和图像。',

        // 第二部分：Why Choose WeryAI
        whyChooseTitle: '为什么 WeryAI 是最好的 AI 内容生成器？',
        whyChooseDesc:
            'WeryAI 专为创作者、营销人员、设计师、开发者以及任何想要将创意快速、轻松转化为高质量视觉内容的人设计。\n以下是 WeryAI 成为领先 AI 视频和图像创作平台的核心优势。',

        // 8个特性
        feature1Title: '一站式接入顶级 AI 模型（Kling、Flux、Sora）',
        feature1Desc: `别再为多个订阅反复付费。在一个仪表盘里同时使用 GPT-4o、Google Veo、Wan 2.5、Nano Banana 等模型——真正的 AI 模型聚合平台。`,
        feature2Title: `AI 视频工具：换脸、唇形同步与超分`,
        feature2Desc: `不止生成，更能编辑。用 AI 视频换脸、自动唇形同步、字幕擦除、4K 视频超分，把剪辑时间减少 90%。`,
        feature3Title: `文本生成视频与图片`,
        feature3Desc: `把文字提示一键变成逼真的 4K 视频与图片。支持电影感镜头、动漫风格、写实人像等，基于最新的生成引擎。`,
        feature4Title: `AI 角色与身体动作迁移`,
        feature4Desc: `用 Motion Imitation（Viggle 风格）让照片“跳舞”，在视频里自然换脸，或为故事创建风格统一、可持续的 AI 角色。`,
        feature5Title: `图生视频与视频转视频`,
        feature5Desc: `不用从零开始。上传照片让它动起来（Img2Vid），或把现有视频（Vid2Vid）即时重绘成动漫/黏土风等风格。`,
        feature6Title: `电商与产品摄影 AI`,
        feature6Desc: `瞬间抠图去背景，用 AI Image Background Changer 生成产品展示图，快速产出更能转化的营销素材。`,
        feature7Title: '上下文感知的智能 AI',
        feature7Desc:
            'WeryAI 自动检测面部、物体、场景、光线和上下文，以提供精准的结果。',
        feature8Title: 'API 和批量工具',
        feature8Desc:
            '使用批量处理工具或 API 集成扩展工作流程，实现高容量创意自动化。',

        // 第三部分：How to Use
        howToUseTitle: '4 步生成 AI 视频与图片',
        step1Title: '选择工具',
        step1Desc: `从文生视频、换脸或图片生成器中选择。`,
        step2Title: '输入提示词或上传素材',
        step2Desc: `输入文字描述，或上传你的照片/视频作为参考。`,
        step3Title: '选择模型',
        step3Desc: `在 Kling、Veo 或 Flux 之间切换，得到你想要的风格。`,
        step4Title: '生成并导出',
        step4Desc: `几秒出结果。无需复杂剪辑技能，也能下载 HD/4K。`,

        // 第四部分：FAQ
        faqTitle: '关于 WeryAI 的常见问题',
        faqDesc:
            'WeryAI 专为创作者、营销人员、设计师、开发者以及任何想要将创意快速、轻松转化为高质量视觉内容的人设计。\n以下是 WeryAI 成为领先 AI 视频和图像创作平台的核心优势。',
        faq1Question: '为什么比起单独使用各个模型，WeryAI 更好？',
        faq1Answer: `WeryAI 是一个聚合平台。与其分别为 Kling、Midjourney 或 Runway 付费订阅，你可以在一个仪表盘中访问所有顶级模型（Kling 2.5、Flux Pro、Google Veo）。省钱，也能让你的工作流程更高效。`,
        faq2Question: 'WeryAI 可以免费使用吗？',
        faq2Answer: `可以。我们提供丰厚的每日免费积分，让你体验文生视频、换脸和图片生成器等工具。无需信用卡即可开始。对于高频使用和无水印下载，我们也提供灵活的付费方案。`,
        faq3Question: '这个平台可以使用 Kling AI 和 Flux 吗？',
        faq3Answer: `当然可以。WeryAI 集成了 Kling（生成写实视频）、Flux（高保真图片）以及 Google Veo 的最新版本。我们每周更新模型库，确保你始终用到最新前沿能力。`,
        faq4Question: '如何提升低清/模糊视频的画质？',
        faq4Answer: `使用我们的 AI 视频超分工具。它会自动去噪、去模糊，并将素材提升到 4K 分辨率。非常适合修复老家庭录像或提升社交媒体视频质量。`,
        faq5Question: '我拥有作品的商业版权吗？',
        faq5Answer: `如果你使用的是付费计划，是的。你将拥有在 WeryAI 生成的所有素材的完整商业使用权，可安全用于 YouTube 变现、客户项目和营销活动。`,
        faq6Question: '使用 WeryAI 需要编辑技能吗？',
        faq6Answer:
            '不需要任何经验——WeryAI 自动化复杂的视频和图像编辑，让任何人都能在几秒钟内创建专业效果。',
    },
    tw: {
        // 按鈕
        expandMore: '展開更多內容',
        collapse: '收起',

        // 第一部分：標題介紹
        mainTitle: '免費的一站式 AI 影片與圖片生成平台',
        mainDesc1:
            '在一個地方存取全球頂級 AI 模型。用 Kling AI、Google Veo 與 Sora 生成電影感影片，用 FLUX 與 Wan AI 創作逼真藝術作品，或使用換臉、影片超分等高級工具。無需來回切換應用——專注創作即可。',
        mainDesc2: '使用最快速、最直觀的 AI 創作平台，即刻建立專業影片和圖像。',

        // 第二部分：Why Choose WeryAI
        whyChooseTitle: '為什麼 WeryAI 是最好的 AI 內容生成器？',
        whyChooseDesc:
            'WeryAI 專為創作者、行銷人員、設計師、開發者以及任何想要將創意快速、輕鬆轉化為高品質視覺內容的人設計。\n以下是 WeryAI 成為領先 AI 影片與圖像創作平台的核心優勢。',

        // 8個特性
        feature1Title: '一站式接入頂級 AI 模型（Kling、Flux、Sora）',
        feature1Desc: `別再為多個訂閱反覆付費。在一個儀表板裡同時使用 GPT-4o、Google Veo、Wan 2.5、Nano Banana 等模型——真正的 AI 模型聚合平台。`,
        feature2Title: `AI 影片工具：換臉、唇形同步與超分`,
        feature2Desc: `不止生成，更能編輯。用 AI 影片換臉、自動唇形同步、字幕擦除、4K 影片超分，把剪輯時間減少 90%。`,
        feature3Title: `文字生成影片與圖片`,
        feature3Desc: `把文字提示一鍵變成逼真的 4K 影片與圖片。支援電影感鏡頭、動漫風格、寫實人像等，基於最新的生成引擎。`,
        feature4Title: `AI 角色與身體動作遷移`,
        feature4Desc: `用 Motion Imitation（Viggle 風格）讓照片「跳舞」，在影片裡自然換臉，或為故事建立風格一致、可持續的 AI 角色。`,
        feature5Title: `圖生影片與影片轉影片`,
        feature5Desc: `不用從零開始。上傳照片讓它動起來（Img2Vid），或把現有影片（Vid2Vid）即時重繪成動漫/黏土風等風格。`,
        feature6Title: `電商與產品攝影 AI`,
        feature6Desc: `瞬間去背，用 AI Image Background Changer 生成產品展示圖，快速產出更能轉化的行銷素材。`,
        feature7Title: '上下文感知的智慧 AI',
        feature7Desc:
            'WeryAI 自動檢測臉部、物體、場景、光線與上下文，以提供精準結果。',
        feature8Title: 'API 與批次工具',
        feature8Desc:
            '使用批次處理工具或 API 整合擴展工作流程，實現高容量創意自動化。',

        // 第三部分：How to Use
        howToUseTitle: '4 步生成 AI 影片與圖片',
        step1Title: '選擇工具',
        step1Desc: `從文生影片、換臉或圖片生成器中選擇。`,
        step2Title: '輸入提示詞或上傳素材',
        step2Desc: `輸入文字描述，或上傳你的照片/影片作為參考。`,
        step3Title: '選擇模型',
        step3Desc: `在 Kling、Veo 或 Flux 之間切換，得到你想要的風格。`,
        step4Title: '生成並匯出',
        step4Desc: `幾秒出結果。無需複雜剪輯技能，也能下載 HD/4K。`,

        // 第四部分：FAQ
        faqTitle: '關於 WeryAI 的常見問題',
        faqDesc:
            'WeryAI 專為創作者、行銷人員、設計師、開發者以及任何想要將創意快速、輕鬆轉化為高品質視覺內容的人設計。\n以下是 WeryAI 成為領先 AI 影片與圖像創作平台的核心優勢。',
        faq1Question: '為什麼比起單獨使用各個模型，WeryAI 更好？',
        faq1Answer: `WeryAI 是一個聚合平台。與其分別為 Kling、Midjourney 或 Runway 付費訂閱，你可以在一個儀表板中存取所有頂級模型（Kling 2.5、Flux Pro、Google Veo）。省錢，也能讓你的工作流程更高效。`,
        faq2Question: 'WeryAI 可以免費使用嗎？',
        faq2Answer: `可以。我們提供豐厚的每日免費點數，讓你體驗文生影片、換臉和圖片生成器等工具。無需信用卡即可開始。對於高頻使用和無浮水印下載，我們也提供彈性的付費方案。`,
        faq3Question: '這個平台可以使用 Kling AI 和 Flux 嗎？',
        faq3Answer: `當然可以。WeryAI 整合了 Kling（生成寫實影片）、Flux（高保真圖片）以及 Google Veo 的最新版本。我們每週更新模型庫，確保你始終用到最新前沿能力。`,
        faq4Question: '如何提升低清/模糊影片的畫質？',
        faq4Answer: `使用我們的 AI 影片超分工具。它會自動去噪、去模糊，並將素材提升到 4K 解析度。非常適合修復老家庭錄影或提升社群媒體影片品質。`,
        faq5Question: '我擁有作品的商業版權嗎？',
        faq5Answer: `如果你使用的是付費方案，是的。你將擁有在 WeryAI 生成的所有素材的完整商業使用權，可安全用於 YouTube 變現、客戶專案和行銷活動。`,
        faq6Question: '使用 WeryAI 需要編輯技能嗎？',
        faq6Answer:
            '不需要任何經驗——WeryAI 自動化複雜的影片與圖像編輯，讓任何人都能在幾秒鐘內建立專業效果。',
    },
    en: {
        // Buttons
        expandMore: 'Expand More',
        collapse: 'Collapse',

        // Section 1: Title Introduction
        mainTitle: 'Free All-in-One AI Video & Image Generator Platform',
        mainDesc1: `Access the world's best AI models in one place. Generate cinematic videos with Kling AI, Google Veo & Sora, create realistic art with FLUX & Wan AI, or use advanced tools like Face Swap and Video Upscaler. No switching apps—just pure creation.`,
        mainDesc2:
            'Create professional videos and images instantly with the fastest and most intuitive AI creation platform.',

        // Section 2: Why Choose WeryAI
        whyChooseTitle: 'Why WeryAI is the Best AI Content Generator?',
        whyChooseDesc:
            'WeryAI is designed for creators, marketers, designers, developers, and anyone who wants to turn ideas into high-quality visuals—quickly and effortlessly.\nBelow are the core strengths that make WeryAI a leading AI video & image creation platform.',

        // 8 Features
        feature1Title: 'Access Top AI Models (Kling, Flux, Sora)',
        feature1Desc: `Stop paying for multiple subscriptions. Use GPT-4o, Google Veo, Wan 2.5, and Nano Banana all in one dashboard. The ultimate AI model aggregator.`,
        feature2Title: `AI Video Tools: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Beyond generation. Cut editing time by 90% with AI Video Face Swap, auto Lip Sync, Subtitle Eraser, and 4K Video Upscaler.`,
        feature3Title: `Text to Video & Image Generation`,
        feature3Desc: `Turn text prompts into realistic 4K videos and images. Support for cinematic shots, anime styles, and photorealistic portraits using the latest generative engines.`,
        feature4Title: `AI Character & Body Motion Transfer`,
        feature4Desc: `Make photos dance with Motion Imitation (Viggle style), swap faces in videos seamlessly, or create consistent AI characters for your stories.`,
        feature5Title: `Image-to-Video & Video-to-Video`,
        feature5Desc: `Don't start from scratch. Upload a photo to animate it (Img2Vid) or restyle existing footage (Vid2Vid) into anime or claymation styles instantly.`,
        feature6Title: `E-commerce & Product Photography AI`,
        feature6Desc: `Remove backgrounds instantly, generate product showcases with AI Image Background Changer, and create marketing assets that convert.`,
        feature7Title: 'Context-Aware Smart AI',
        feature7Desc:
            'WeryAI automatically detects faces, objects, scenes, lighting, and context to deliver precise results.',
        feature8Title: 'API & Batch Tools',
        feature8Desc:
            'Scale your workflow with batch processing tools or API integration for high-volume creative automation.',

        // Section 3: How to Use
        howToUseTitle: 'How to Generate AI Video & Images in 4 Steps',
        step1Title: 'Select a Tool',
        step1Desc: `Choose from Text-to-Video, Face Swap, or Image Generator.`,
        step2Title: 'Input Prompt or Upload',
        step2Desc: `Type a text description or upload your photo/video reference.`,
        step3Title: 'Choose Model',
        step3Desc: `Switch between Kling, Veo, or Flux to get the exact style you want.`,
        step4Title: 'Generate & Export',
        step4Desc: `Get results in seconds. Download in HD/4K without complex editing skills.`,

        // Section 4: FAQ
        faqTitle: 'Frequently Asked Questions about WeryAI',
        faqDesc:
            'WeryAI is designed for creators, marketers, designers, developers, and anyone who wants to turn ideas into high-quality visuals—quickly and effortlessly.\nBelow are the core strengths that make WeryAI a leading AI video & image creation platform.',

        faq1Question: 'Why is WeryAI better than using models separately?',
        faq1Answer: `WeryAI acts as an aggregator. Instead of paying separate subscriptions for Kling, Midjourney, or Runway, you get access to all top-tier models (Kling 2.5, Flux Pro, Google Veo) in a single dashboard. It saves you money and streamlines your workflow.`,
        faq2Question: 'Is WeryAI free to use?',
        faq2Answer: `Yes. We offer generous daily free credits that let you test drive our Text-to-Video, Face Swap, and Image Generator tools. No credit card is needed to start. For heavy usage and no-watermark downloads, flexible paid plans are available.`,
        faq3Question: 'Can I use Kling AI and Flux on this platform?',
        faq3Answer: `Absolutely. WeryAI integrates the latest versions of Kling (for realistic video), Flux (for high-fidelity images), and Google Veo. We update our model library weekly so you always have access to the cutting edge.`,
        faq4Question: 'How can I improve my low-quality videos?',
        faq4Answer: `Use our AI Video Upscaler. It automatically removes noise/blur and upscales footage to 4K resolution. It's perfect for restoring old family videos or improving social media clips.`,
        faq5Question: 'Do I own the commercial rights to my creations?',
        faq5Answer: `If you are on a paid plan, yes. You own full commercial rights to all assets generated on WeryAI, making them safe for YouTube monetization, client work, and marketing campaigns.`,
    },
    ja: {
        // ボタン
        expandMore: 'もっと見る',
        collapse: '閉じる',

        // セクション1：タイトル紹介
        mainTitle: '無料のオールインワンAI動画・画像生成プラットフォーム',
        mainDesc1:
            '世界最高クラスのAIモデルを一か所で利用。Kling AI、Google Veo、Soraでシネマティックな動画を生成し、FLUXとWan AIでリアルなアートを作成。さらにフェイススワップや動画アップスケーラーなどの高度なツールも利用可能。アプリを切り替える必要はありません—創作に集中できます。',
        mainDesc2:
            '最速かつ最も直感的なAI作成プラットフォームで、プロフェッショナルな動画と画像を瞬時に作成。',

        // セクション2：Why Choose WeryAI
        whyChooseTitle: 'なぜWeryAIは最高のAIコンテンツジェネレーターなのか？',
        whyChooseDesc:
            'WeryAIは、クリエイター、マーケター、デザイナー、開発者、そしてアイデアを高品質なビジュアルに素早く簡単に変換したい方のために設計されています。\n以下は、WeryAIを主要なAI動画・画像作成プラットフォームにする核心的な強みです。',

        // 8つの機能
        feature1Title: 'トップAIモデルにアクセス（Kling、Flux、Sora）',
        feature1Desc: `複数のサブスク料金を払うのはもう終わり。GPT-4o、Google Veo、Wan 2.5、Nano Bananaを1つのダッシュボードで利用できます。究極のAIモデル統合プラットフォーム。`,
        feature2Title: `AI動画ツール：フェイススワップ、リップシンク、アップスケール`,
        feature2Desc: `生成だけで終わらない。AI動画フェイススワップ、自動リップシンク、字幕消し、4K動画アップスケーラーで編集時間を90%削減。`,
        feature3Title: `テキストから動画・画像生成`,
        feature3Desc: `テキストプロンプトをリアルな4K動画・画像に変換。最新の生成エンジンで、シネマティックなショット、アニメ風、フォトリアルなポートレートに対応。`,
        feature4Title: `AIキャラクター＆ボディのモーション転送`,
        feature4Desc: `Motion Imitation（Viggle風）で写真を踊らせたり、動画の顔を自然に入れ替えたり、ストーリー用に一貫したAIキャラクターを作成。`,
        feature5Title: `画像→動画＆動画→動画`,
        feature5Desc: `ゼロから始めなくていい。写真をアップロードして動かす（Img2Vid）か、既存映像（Vid2Vid）をアニメやクレイアニメ風に即リスタイル。`,
        feature6Title: `Eコマース＆商品撮影AI`,
        feature6Desc: `背景を瞬時に削除し、AI Image Background Changerで商品ビジュアルを生成。コンバージョンにつながるマーケ素材を作成。`,
        feature7Title: 'コンテキスト認識スマートAI',
        feature7Desc:
            'WeryAIは顔、オブジェクト、シーン、照明、コンテキストを自動検出し、正確な結果を提供。',
        feature8Title: 'API＆バッチツール',
        feature8Desc:
            'バッチ処理ツールやAPI統合でワークフローを拡張し、大量のクリエイティブ自動化を実現。',

        // セクション3：How to Use
        howToUseTitle: '4ステップでAI動画・画像を生成する方法',
        step1Title: 'ツールを選ぶ',
        step1Desc: `Text-to-Video（テキスト→動画）、Face Swap（顔交換）、Image Generator（画像生成）から選択。`,
        step2Title: 'プロンプトを入力、またはアップロード',
        step2Desc: `テキストで説明を入力するか、写真／動画の参照をアップロードします。`,
        step3Title: 'モデルを選ぶ',
        step3Desc: `Kling、Veo、Flux を切り替えて、狙いのスタイルに合わせます。`,
        step4Title: '生成してエクスポート',
        step4Desc: `数秒で結果を取得。複雑な編集スキルなしでHD/4Kでダウンロード。`,

        // セクション4：FAQ
        faqTitle: 'WeryAIに関するよくある質問',
        faqDesc:
            'WeryAIは、クリエイター、マーケター、デザイナー、開発者、そしてアイデアを高品質なビジュアルに素早く簡単に変換したい方のために設計されています。\n以下は、WeryAIを主要なAI動画・画像作成プラットフォームにする核心的な強みです。',
        faq1Question: 'モデルを個別に使うより、なぜWeryAIの方が良いのですか？',
        faq1Answer: `WeryAIはアグリゲーター（統合プラットフォーム）です。Kling、Midjourney、Runwayなどに個別に課金する代わりに、トップモデル（Kling 2.5、Flux Pro、Google Veo）を1つのダッシュボードでまとめて利用できます。コストを抑え、ワークフローも効率化できます。`,
        faq2Question: 'WeryAIは無料で使えますか？',
        faq2Answer: `はい。毎日付与される無料クレジットで、Text-to-Video、Face Swap、Image Generatorを気軽に試せます。開始にクレジットカードは不要です。高頻度の利用や透かしなしダウンロード向けに柔軟な有料プランも用意しています。`,
        faq3Question: 'このプラットフォームでKling AIとFluxは使えますか？',
        faq3Answer: `もちろんです。WeryAIはKling（リアルな動画）、Flux（高品質画像）、Google Veoの最新バージョンを統合しています。モデルライブラリは毎週更新され、常に最先端を利用できます。`,
        faq4Question: '画質の低い動画を改善するには？',
        faq4Answer: `AI Video Upscaler（動画アップスケーラー）をご利用ください。ノイズやブラーを自動で除去し、4K解像度までアップスケールします。古い家族動画の復元やSNSクリップの改善に最適です。`,
        faq5Question: '生成した作品の商用権利は自分のものですか？',
        faq5Answer: `有料プランをご利用の場合、はい。WeryAIで生成したすべての素材の完全な商用利用権を保有でき、YouTube収益化、クライアントワーク、マーケティング施策に安心して使えます。`,
        faq6Question: 'WeryAIを使用するには編集スキルが必要ですか？',
        faq6Answer:
            '経験は不要です—WeryAIは複雑な動画・画像編集を自動化し、誰でも数秒でプロフェッショナルな結果を作成できます。',
    },
    ko: {
        // 버튼
        expandMore: '더 보기',
        collapse: '접기',

        // 섹션 1: 타이틀 소개
        mainTitle: '무료 올인원 AI 비디오 & 이미지 생성 플랫폼',
        mainDesc1:
            '세계 최고의 AI 모델을 한곳에서 이용하세요. Kling AI, Google Veo, Sora로 시네마틱 영상을 만들고, FLUX와 Wan AI로 사실적인 아트를 생성하거나 Face Swap, Video Upscaler 같은 고급 도구를 사용하세요. 앱을 옮겨 다닐 필요 없이—오로지 창작에만 집중하면 됩니다.',
        mainDesc2:
            '가장 빠르고 직관적인 AI 제작 플랫폼으로 전문적인 비디오와 이미지를 즉시 생성하세요.',

        // 섹션 2: Why Choose WeryAI
        whyChooseTitle: '왜 WeryAI가 최고의 AI 콘텐츠 생성기일까요?',
        whyChooseDesc:
            'WeryAI는 크리에이터, 마케터, 디자이너, 개발자, 그리고 아이디어를 빠르고 쉽게 고품질 비주얼로 전환하고자 하는 모든 분을 위해 설계되었습니다.\n아래는 WeryAI를 선도적인 AI 비디오 & 이미지 제작 플랫폼으로 만드는 핵심 강점입니다.',

        // 8가지 기능
        feature1Title: '최고의 AI 모델 액세스(Kling, Flux, Sora)',
        feature1Desc: `여러 구독료를 더 이상 내지 마세요. GPT-4o, Google Veo, Wan 2.5, Nano Banana를 하나의 대시보드에서 모두 사용하세요. 궁극의 AI 모델 통합 플랫폼입니다.`,
        feature2Title: `AI 비디오 도구: 페이스 스왑, 립싱크 & 업스케일`,
        feature2Desc: `생성 그 이상. AI 비디오 페이스 스왑, 자동 립싱크, 자막 제거, 4K 비디오 업스케일러로 편집 시간을 90% 줄이세요.`,
        feature3Title: `텍스트→비디오 & 이미지 생성`,
        feature3Desc: `텍스트 프롬프트를 사실적인 4K 비디오와 이미지로 변환하세요. 최신 생성 엔진으로 시네마틱 샷, 애니 스타일, 포토리얼 인물까지 지원합니다.`,
        feature4Title: `AI 캐릭터 & 바디 모션 전송`,
        feature4Desc: `모션 이미테이션(Viggle 스타일)로 사진을 춤추게 하거나, 영상에서 얼굴을 자연스럽게 바꾸거나, 스토리를 위한 일관된 AI 캐릭터를 만들 수 있습니다.`,
        feature5Title: `이미지→비디오 & 비디오→비디오`,
        feature5Desc: `처음부터 만들 필요가 없습니다. 사진을 업로드해 움직이게(Img2Vid) 하거나, 기존 영상(Vid2Vid)을 애니/클레이메이션 스타일로 즉시 리스타일하세요.`,
        feature6Title: `이커머스 & 제품 사진 AI`,
        feature6Desc: `배경을 즉시 제거하고, AI Image Background Changer로 제품 쇼케이스를 생성해 전환을 높이는 마케팅 소재를 만드세요.`,
        feature7Title: '컨텍스트 인식 스마트 AI',
        feature7Desc:
            'WeryAI는 얼굴, 객체, 장면, 조명 및 컨텍스트를 자동으로 감지하여 정확한 결과를 제공합니다.',
        feature8Title: 'API & 배치 도구',
        feature8Desc:
            '배치 처리 도구나 API 통합으로 워크플로우를 확장하여 대량 창작 자동화를 실현하세요.',

        // 섹션 3: How to Use
        howToUseTitle: '4단계로 AI 비디오·이미지 생성하기',
        step1Title: '도구 선택',
        step1Desc: `텍스트-투-비디오, 페이스 스왑, 이미지 생성기 중에서 선택하세요.`,
        step2Title: '프롬프트 입력 또는 업로드',
        step2Desc: `텍스트 설명을 입력하거나 사진/영상 레퍼런스를 업로드하세요.`,
        step3Title: '모델 선택',
        step3Desc: `원하는 스타일을 위해 Kling, Veo 또는 Flux로 전환하세요.`,
        step4Title: '생성 및 내보내기',
        step4Desc: `몇 초 만에 결과를 확인하세요. 복잡한 편집 기술 없이도 HD/4K로 다운로드할 수 있습니다.`,

        // 섹션 4: FAQ
        faqTitle: 'WeryAI 자주 묻는 질문',
        faqDesc:
            'WeryAI는 크리에이터, 마케터, 디자이너, 개발자, 그리고 아이디어를 빠르고 쉽게 고품질 비주얼로 전환하고자 하는 모든 분을 위해 설계되었습니다.\n아래는 WeryAI를 선도적인 AI 비디오 & 이미지 제작 플랫폼으로 만드는 핵심 강점입니다.',
        faq1Question:
            '모델을 따로 쓰는 것보다 WeryAI가 더 좋은 이유는 무엇인가요?',
        faq1Answer: `WeryAI는 모델 통합(애그리게이터) 플랫폼입니다. Kling, Midjourney, Runway에 각각 구독료를 내는 대신, 하나의 대시보드에서 최상위 모델(Kling 2.5, Flux Pro, Google Veo)을 모두 사용할 수 있어 비용을 절감하고 워크플로우도 단순화합니다.`,
        faq2Question: 'WeryAI는 무료로 사용할 수 있나요?',
        faq2Answer: `네. 매일 제공되는 넉넉한 무료 크레딧으로 Text-to-Video, Face Swap, Image Generator를 체험할 수 있습니다. 시작에 신용카드는 필요 없습니다. 고사용량 및 무워터마크 다운로드를 위한 유연한 유료 플랜도 제공됩니다.`,
        faq3Question: '이 플랫폼에서 Kling AI와 Flux를 사용할 수 있나요?',
        faq3Answer: `물론입니다. WeryAI는 사실적인 비디오를 위한 Kling, 고해상도 이미지를 위한 Flux, 그리고 Google Veo의 최신 버전을 통합합니다. 모델 라이브러리는 매주 업데이트되어 항상 최신 기술을 사용할 수 있습니다.`,
        faq4Question: '저화질 비디오를 어떻게 개선할 수 있나요?',
        faq4Answer: `AI Video Upscaler를 사용해 보세요. 노이즈/블러를 자동으로 제거하고 영상을 4K 해상도로 업스케일합니다. 오래된 가족 영상 복원이나 SNS 클립 품질 향상에 적합합니다.`,
        faq5Question: '생성한 결과물의 상업적 권리를 제가 가지나요?',
        faq5Answer: `유료 플랜을 이용 중이라면, 네. WeryAI에서 생성한 모든 자산에 대한 완전한 상업적 권리를 보유하며, YouTube 수익화, 클라이언트 작업, 마케팅 캠페인에 안전하게 사용할 수 있습니다.`,
        faq6Question: 'WeryAI를 사용하려면 편집 기술이 필요한가요?',
        faq6Answer:
            '경험이 필요 없습니다—WeryAI는 복잡한 비디오 및 이미지 편집을 자동화하여 누구나 몇 초 만에 전문적인 결과를 만들 수 있습니다.',
    },
    es: {
        // Botones
        expandMore: 'Expandir más',
        collapse: 'Contraer',

        // Sección 1: Introducción del título
        mainTitle:
            'Plataforma gratuita todo en uno para generar video e imagen con IA',
        mainDesc1:
            'Accede a los mejores modelos de IA del mundo en un solo lugar. Genera videos cinematográficos con Kling AI, Google Veo y Sora, crea arte realista con FLUX y Wan AI, o usa herramientas avanzadas como Face Swap y Video Upscaler. Sin cambiar de apps: solo creación.',
        mainDesc2:
            'Crea videos e imágenes profesionales al instante con la plataforma de creación de IA más rápida e intuitiva.',

        // Sección 2: Why Choose WeryAI
        whyChooseTitle:
            '¿Por qué WeryAI es el mejor generador de contenido con IA?',
        whyChooseDesc:
            'WeryAI está diseñado para creadores, marketers, diseñadores, desarrolladores y cualquiera que quiera convertir ideas en visuales de alta calidad, de forma rápida y sin esfuerzo.\nA continuación se presentan las fortalezas principales que hacen de WeryAI una plataforma líder de creación de video e imagen con IA.',

        // 8 Características
        feature1Title: 'Accede a los mejores modelos de IA (Kling, Flux, Sora)',
        feature1Desc: `Deja de pagar varias suscripciones. Usa GPT-4o, Google Veo, Wan 2.5 y Nano Banana en un solo panel. El agregador definitivo de modelos de IA.`,
        feature2Title: `Herramientas de video con IA: Face Swap, Lip Sync y Upscale`,
        feature2Desc: `Más allá de la generación. Reduce el tiempo de edición en un 90% con Face Swap en video, Lip Sync automático, Borrador de Subtítulos y un Upscaler de video 4K.`,
        feature3Title: `Texto a video y generación de imágenes`,
        feature3Desc: `Convierte prompts de texto en videos e imágenes 4K realistas. Compatible con tomas cinematográficas, estilos anime y retratos fotorrealistas usando los motores generativos más recientes.`,
        feature4Title: `Transferencia de movimiento de personajes y cuerpo con IA`,
        feature4Desc: `Haz “bailar” tus fotos con Motion Imitation (estilo Viggle), intercambia caras en videos sin esfuerzo o crea personajes de IA consistentes para tus historias.`,
        feature5Title: `Imagen a video y video a video`,
        feature5Desc: `No empieces desde cero. Sube una foto para animarla (Img2Vid) o reestiliza metraje existente (Vid2Vid) a estilos anime o plastilina al instante.`,
        feature6Title: `IA para e-commerce y fotografía de productos`,
        feature6Desc: `Elimina fondos al instante, genera showcases de productos con AI Image Background Changer y crea piezas de marketing que convierten.`,
        feature7Title: 'IA Inteligente Consciente del Contexto',
        feature7Desc:
            'WeryAI detecta automáticamente caras, objetos, escenas, iluminación y contexto para entregar resultados precisos.',
        feature8Title: 'API y Herramientas por Lotes',
        feature8Desc:
            'Escala tu flujo de trabajo con herramientas de procesamiento por lotes o integración de API para automatización creativa de alto volumen.',

        // Sección 3: How to Use
        howToUseTitle: 'Cómo generar video e imágenes con IA en 4 pasos',
        step1Title: 'Elige una herramienta',
        step1Desc: `Elige entre Text-to-Video, Face Swap o Image Generator.`,
        step2Title: 'Escribe un prompt o sube un archivo',
        step2Desc: `Escribe una descripción o sube tu referencia de foto/video.`,
        step3Title: 'Elige un modelo',
        step3Desc: `Cambia entre Kling, Veo o Flux para obtener el estilo exacto que quieres.`,
        step4Title: 'Genera y exporta',
        step4Desc: `Obtén resultados en segundos. Descarga en HD/4K sin necesidad de habilidades complejas de edición.`,

        // Sección 4: FAQ
        faqTitle: 'Preguntas frecuentes sobre WeryAI',
        faqDesc:
            'WeryAI está diseñado para creadores, marketers, diseñadores, desarrolladores y cualquiera que quiera convertir ideas en visuales de alta calidad, de forma rápida y sin esfuerzo.\nA continuación se presentan las fortalezas principales que hacen de WeryAI una plataforma líder de creación de video e imagen con IA.',
        faq1Question:
            '¿Por qué WeryAI es mejor que usar los modelos por separado?',
        faq1Answer: `WeryAI actúa como un agregador. En lugar de pagar suscripciones separadas para Kling, Midjourney o Runway, obtienes acceso a modelos de primer nivel (Kling 2.5, Flux Pro, Google Veo) en un solo panel. Ahorras dinero y simplificas tu flujo de trabajo.`,
        faq2Question: '¿WeryAI se puede usar gratis?',
        faq2Answer: `Sí. Ofrecemos generosos créditos diarios gratuitos para que pruebes nuestras herramientas de Text-to-Video, Face Swap e Image Generator. No necesitas tarjeta para empezar. Para uso intensivo y descargas sin marca de agua, hay planes de pago flexibles.`,
        faq3Question: '¿Puedo usar Kling AI y Flux en esta plataforma?',
        faq3Answer: `Por supuesto. WeryAI integra las versiones más recientes de Kling (para video realista), Flux (para imágenes de alta fidelidad) y Google Veo. Actualizamos nuestra biblioteca de modelos semanalmente para que siempre tengas acceso a lo último.`,
        faq4Question: '¿Cómo puedo mejorar videos de baja calidad?',
        faq4Answer: `Usa nuestro AI Video Upscaler. Elimina automáticamente ruido/desenfoque y escala el metraje a resolución 4K. Es perfecto para restaurar videos familiares antiguos o mejorar clips de redes sociales.`,
        faq5Question:
            '¿Soy dueño de los derechos comerciales de mis creaciones?',
        faq5Answer: `Si estás en un plan de pago, sí. Tienes derechos comerciales completos sobre todos los assets generados en WeryAI, lo que los hace seguros para monetización en YouTube, trabajos para clientes y campañas de marketing.`,
        faq6Question: '¿Necesito habilidades de edición para usar WeryAI?',
        faq6Answer:
            'No se necesita experiencia: WeryAI automatiza la edición compleja de video e imagen para que cualquiera pueda crear resultados profesionales en segundos.',
    },
    fr: {
        // Boutons
        expandMore: 'Développer plus',
        collapse: 'Réduire',

        // Section 1: Introduction du titre
        mainTitle:
            'Plateforme gratuite tout-en-un de génération vidéo et image par IA',
        mainDesc1:
            "Accédez aux meilleurs modèles d'IA du monde au même endroit. Générez des vidéos cinématographiques avec Kling AI, Google Veo et Sora, créez un art réaliste avec FLUX et Wan AI, ou utilisez des outils avancés comme Face Swap et Video Upscaler. Plus besoin de changer d'apps : place à la création.",
        mainDesc2:
            'Créez des vidéos et images professionnelles instantanément avec la plateforme de création IA la plus rapide et intuitive.',

        // Section 2: Why Choose WeryAI
        whyChooseTitle:
            'Pourquoi WeryAI est le meilleur générateur de contenu IA ?',
        whyChooseDesc:
            'WeryAI est conçu pour les créateurs, marketeurs, designers, développeurs et tous ceux qui veulent transformer leurs idées en visuels de haute qualité, rapidement et sans effort.\nVoici les forces principales qui font de WeryAI une plateforme leader de création vidéo et image par IA.',

        // 8 Fonctionnalités
        feature1Title: 'Accédez aux meilleurs modèles d’IA (Kling, Flux, Sora)',
        feature1Desc: `Arrêtez de payer plusieurs abonnements. Utilisez GPT-4o, Google Veo, Wan 2.5 et Nano Banana dans un seul tableau de bord. L’agrégateur ultime de modèles d’IA.`,
        feature2Title: `Outils vidéo IA : Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Au-delà de la génération. Réduisez le temps de montage de 90 % avec le Face Swap vidéo, le Lip Sync automatique, l’effaceur de sous-titres et l’upscaler vidéo 4K.`,
        feature3Title: `Texte vers vidéo & génération d’images`,
        feature3Desc: `Transformez des prompts en vidéos et images 4K réalistes. Prise en charge des plans cinématographiques, des styles anime et des portraits photoréalistes grâce aux moteurs génératifs les plus récents.`,
        feature4Title: `Transfert de mouvement IA (personnage & corps)`,
        feature4Desc: `Faites “danser” des photos avec Motion Imitation (style Viggle), échangez des visages dans des vidéos en toute fluidité ou créez des personnages IA cohérents pour vos histoires.`,
        feature5Title: `Image vers vidéo & vidéo vers vidéo`,
        feature5Desc: `Ne partez pas de zéro. Téléversez une photo pour l’animer (Img2Vid) ou re-stylisez une vidéo existante (Vid2Vid) en style anime ou stop-motion pâte à modeler, instantanément.`,
        feature6Title: `IA e-commerce & photographie produit`,
        feature6Desc: `Supprimez les arrière-plans instantanément, générez des visuels produits avec AI Image Background Changer et créez des assets marketing qui convertissent.`,
        feature7Title: 'IA Intelligente Consciente du Contexte',
        feature7Desc:
            'WeryAI détecte automatiquement les visages, objets, scènes, éclairage et contexte pour fournir des résultats précis.',
        feature8Title: 'API et Outils par Lots',
        feature8Desc:
            "Faites évoluer votre workflow avec des outils de traitement par lots ou l'intégration API pour l'automatisation créative à haut volume.",

        // Section 3: How to Use
        howToUseTitle: 'Générez des vidéos et images IA en 4 étapes',
        step1Title: 'Choisissez un outil',
        step1Desc: `Choisissez entre Text-to-Video, Face Swap ou Image Generator.`,
        step2Title: 'Saisissez un prompt ou téléversez',
        step2Desc: `Tapez une description ou téléversez votre référence photo/vidéo.`,
        step3Title: 'Choisissez un modèle',
        step3Desc: `Basculez entre Kling, Veo ou Flux pour obtenir le style exact voulu.`,
        step4Title: 'Générez et exportez',
        step4Desc: `Résultats en quelques secondes. Téléchargez en HD/4K sans compétences complexes de montage.`,

        // Section 4: FAQ
        faqTitle: 'FAQ sur WeryAI',
        faqDesc:
            'WeryAI est conçu pour les créateurs, marketeurs, designers, développeurs et tous ceux qui veulent transformer leurs idées en visuels de haute qualité, rapidement et sans effort.\nVoici les forces principales qui font de WeryAI une plateforme leader de création vidéo et image par IA.',
        faq1Question:
            'Pourquoi WeryAI est-il meilleur que d’utiliser les modèles séparément ?',
        faq1Answer: `WeryAI agit comme un agrégateur. Au lieu de payer des abonnements séparés pour Kling, Midjourney ou Runway, vous accédez à tous les meilleurs modèles (Kling 2.5, Flux Pro, Google Veo) depuis un seul tableau de bord. Vous économisez de l’argent et simplifiez votre workflow.`,
        faq2Question: 'WeryAI est-il gratuit ?',
        faq2Answer: `Oui. Nous proposons de généreux crédits gratuits quotidiens pour tester nos outils Text-to-Video, Face Swap et Image Generator. Aucune carte bancaire n’est nécessaire pour commencer. Pour un usage intensif et des téléchargements sans filigrane, des formules payantes flexibles sont disponibles.`,
        faq3Question:
            'Puis-je utiliser Kling AI et Flux sur cette plateforme ?',
        faq3Answer: `Absolument. WeryAI intègre les dernières versions de Kling (pour des vidéos réalistes), de Flux (pour des images haute fidélité) et de Google Veo. Nous mettons à jour notre bibliothèque de modèles chaque semaine pour que vous restiez à la pointe.`,
        faq4Question: 'Comment améliorer des vidéos de faible qualité ?',
        faq4Answer: `Utilisez notre AI Video Upscaler. Il supprime automatiquement le bruit/le flou et upscale vos vidéos en 4K. Idéal pour restaurer d’anciennes vidéos familiales ou améliorer des clips pour les réseaux sociaux.`,
        faq5Question:
            'Est-ce que je possède les droits commerciaux sur mes créations ?',
        faq5Answer: `Si vous êtes sur une formule payante, oui. Vous détenez tous les droits commerciaux sur les contenus générés sur WeryAI, ce qui les rend sûrs pour la monétisation YouTube, le travail client et les campagnes marketing.`,
        faq6Question:
            'Ai-je besoin de compétences en édition pour utiliser WeryAI ?',
        faq6Answer:
            "Aucune expérience nécessaire—WeryAI automatise l'édition complexe de vidéo et d'image pour que n'importe qui puisse créer des résultats professionnels en quelques secondes.",
    },
    de: {
        // Buttons
        expandMore: 'Mehr anzeigen',
        collapse: 'Einklappen',

        // Abschnitt 1: Titeleinführung
        mainTitle:
            'Kostenlose All-in-One Plattform für KI-Video- und Bildgenerierung',
        mainDesc1:
            'Greifen Sie an einem Ort auf die besten KI-Modelle der Welt zu. Erstellen Sie filmische Videos mit Kling AI, Google Veo und Sora, erzeugen Sie realistische Kunst mit FLUX und Wan AI oder nutzen Sie fortschrittliche Tools wie Face Swap und Video Upscaler. Kein App-Wechsel – nur pure Kreativität.',
        mainDesc2:
            'Erstellen Sie professionelle Videos und Bilder sofort mit der schnellsten und intuitivsten KI-Erstellungsplattform.',

        // Abschnitt 2: Why Choose WeryAI
        whyChooseTitle: 'Warum ist WeryAI der beste KI-Content-Generator?',
        whyChooseDesc:
            'WeryAI ist für Kreative, Marketer, Designer, Entwickler und alle konzipiert, die Ideen schnell und mühelos in hochwertige Visuals umwandeln möchten.\nIm Folgenden sind die Kernstärken, die WeryAI zu einer führenden KI-Video- und Bilderstellungsplattform machen.',

        // 8 Funktionen
        feature1Title: 'Zugriff auf Top‑KI‑Modelle (Kling, Flux, Sora)',
        feature1Desc: `Hör auf, mehrere Abos zu bezahlen. Nutze GPT-4o, Google Veo, Wan 2.5 und Nano Banana in einem einzigen Dashboard. Der ultimative KI‑Modelle‑Aggregator.`,
        feature2Title: `KI‑Video‑Tools: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Mehr als nur Generierung. Spare 90% Editing‑Zeit mit KI‑Video‑Face‑Swap, automatischem Lip‑Sync, Subtitle Eraser und 4K‑Video‑Upscaler.`,
        feature3Title: `Text‑zu‑Video & Bildgenerierung`,
        feature3Desc: `Wandle Textprompts in realistische 4K‑Videos und Bilder um. Unterstützt cineastische Shots, Anime‑Styles und fotorealistische Porträts mit den neuesten generativen Engines.`,
        feature4Title: `KI‑Charakter‑ & Körper‑Motion‑Transfer`,
        feature4Desc: `Lass Fotos mit Motion Imitation (Viggle‑Style) tanzen, tausche Gesichter in Videos nahtlos aus oder erstelle konsistente KI‑Charaktere für deine Stories.`,
        feature5Title: `Bild‑zu‑Video & Video‑zu‑Video`,
        feature5Desc: `Starte nicht bei null. Lade ein Foto hoch, um es zu animieren (Img2Vid), oder restyle vorhandenes Material (Vid2Vid) sofort in Anime‑ oder Claymation‑Styles.`,
        feature6Title: `E‑Commerce‑ & Produktfotografie‑KI`,
        feature6Desc: `Entferne Hintergründe sofort, erstelle Produkt‑Showcases mit AI Image Background Changer und baue Marketing‑Assets, die konvertieren.`,
        feature7Title: 'Kontextbewusste Intelligente KI',
        feature7Desc:
            'WeryAI erkennt automatisch Gesichter, Objekte, Szenen, Beleuchtung und Kontext, um präzise Ergebnisse zu liefern.',
        feature8Title: 'API & Batch-Tools',
        feature8Desc:
            'Skalieren Sie Ihren Workflow mit Batch-Verarbeitungstools oder API-Integration für kreative Automatisierung mit hohem Volumen.',

        // Abschnitt 3: How to Use
        howToUseTitle: 'KI‑Videos & Bilder in 4 Schritten erstellen',
        step1Title: 'Tool auswählen',
        step1Desc: `Wähle zwischen Text-to-Video, Face Swap oder Image Generator.`,
        step2Title: 'Prompt eingeben oder hochladen',
        step2Desc: `Gib eine Textbeschreibung ein oder lade deine Foto/Video‑Referenz hoch.`,
        step3Title: 'Modell wählen',
        step3Desc: `Wechsle zwischen Kling, Veo oder Flux, um genau den gewünschten Stil zu bekommen.`,
        step4Title: 'Generieren & exportieren',
        step4Desc: `Ergebnisse in Sekunden. Lade in HD/4K herunter – ohne komplexe Editing‑Skills.`,

        // Abschnitt 4: FAQ
        faqTitle: 'Häufig gestellte Fragen zu WeryAI',
        faqDesc:
            'WeryAI ist für Kreative, Marketer, Designer, Entwickler und alle konzipiert, die Ideen schnell und mühelos in hochwertige Visuals umwandeln möchten.\nIm Folgenden sind die Kernstärken, die WeryAI zu einer führenden KI-Video- und Bilderstellungsplattform machen.',
        faq1Question: 'Warum ist WeryAI besser, als Modelle einzeln zu nutzen?',
        faq1Answer: `WeryAI ist ein Aggregator. Statt separate Abos für Kling, Midjourney oder Runway zu bezahlen, erhältst du Zugriff auf alle Top‑Modelle (Kling 2.5, Flux Pro, Google Veo) in einem einzigen Dashboard. Das spart Geld und macht deinen Workflow schlanker.`,
        faq2Question: 'Kann ich WeryAI kostenlos nutzen?',
        faq2Answer: `Ja. Wir bieten großzügige tägliche Gratis‑Credits, mit denen du Text-to-Video, Face Swap und Image Generator testen kannst. Zum Start ist keine Kreditkarte nötig. Für Vielnutzer und Downloads ohne Wasserzeichen gibt es flexible Bezahlpläne.`,
        faq3Question: 'Kann ich Kling AI und Flux auf dieser Plattform nutzen?',
        faq3Answer: `Auf jeden Fall. WeryAI integriert die neuesten Versionen von Kling (für realistische Videos), Flux (für hochqualitative Bilder) und Google Veo. Wir aktualisieren unsere Modellbibliothek wöchentlich, damit du immer Zugriff auf das Neueste hast.`,
        faq4Question: 'Wie kann ich Videos mit niedriger Qualität verbessern?',
        faq4Answer: `Nutze unseren AI Video Upscaler. Er entfernt automatisch Rauschen/Unschärfe und skaliert das Material auf 4K‑Auflösung hoch. Perfekt, um alte Familienvideos zu restaurieren oder Social‑Media‑Clips zu verbessern.`,
        faq5Question:
            'Besitze ich die kommerziellen Rechte an meinen Kreationen?',
        faq5Answer: `Wenn du einen kostenpflichtigen Plan nutzt: ja. Du besitzt volle kommerzielle Rechte an allen Assets, die auf WeryAI generiert werden – sicher für YouTube‑Monetarisierung, Kundenarbeit und Marketing‑Kampagnen.`,
        faq6Question:
            'Brauche ich Bearbeitungskenntnisse, um WeryAI zu nutzen?',
        faq6Answer:
            'Keine Erfahrung nötig – WeryAI automatisiert komplexe Video- und Bildbearbeitung, sodass jeder in Sekunden professionelle Ergebnisse erstellen kann.',
    },
    ru: {
        // Кнопки
        expandMore: 'Развернуть',
        collapse: 'Свернуть',

        // Раздел 1: Заголовок
        mainTitle:
            'Бесплатная универсальная платформа для генерации AI-видео и изображений',
        mainDesc1:
            'Доступ к лучшим AI-моделям мира в одном месте. Создавайте кинематографичные видео с Kling AI, Google Veo и Sora, генерируйте реалистичное искусство с FLUX и Wan AI или используйте продвинутые инструменты вроде Face Swap и Video Upscaler. Никаких переключений между приложениями — только творчество.',
        mainDesc2:
            'Создавайте профессиональные видео и изображения мгновенно с самой быстрой и интуитивной платформой создания на базе ИИ.',

        // Раздел 2: Why Choose WeryAI
        whyChooseTitle: 'Почему WeryAI — лучший генератор AI‑контента?',
        whyChooseDesc:
            'WeryAI создан для креаторов, маркетологов, дизайнеров, разработчиков и всех, кто хочет быстро и легко превращать идеи в высококачественные визуалы.\nНиже представлены ключевые преимущества, которые делают WeryAI ведущей платформой для создания видео и изображений с ИИ.',

        // 8 Функций
        feature1Title: 'Доступ к топ‑ИИ‑моделям (Kling, Flux, Sora)',
        feature1Desc: `Хватит платить за несколько подписок. Используйте GPT-4o, Google Veo, Wan 2.5 и Nano Banana в одной панели управления. Максимальный агрегатор ИИ‑моделей.`,
        feature2Title: `ИИ‑инструменты для видео: Face Swap, Lip Sync и Upscale`,
        feature2Desc: `Больше, чем генерация. Сократите время монтажа на 90% с AI Video Face Swap, авто Lip Sync, Subtitle Eraser и 4K Video Upscaler.`,
        feature3Title: `Текст‑в‑видео и генерация изображений`,
        feature3Desc: `Превращайте текстовые промпты в реалистичные 4K‑видео и изображения. Поддержка киношных кадров, аниме‑стилей и фотореалистичных портретов на базе новейших генеративных движков.`,
        feature4Title: `Перенос движения персонажа и тела с ИИ`,
        feature4Desc: `Заставьте фото “танцевать” с Motion Imitation (в стиле Viggle), меняйте лица в видео без швов или создавайте постоянных AI‑персонажей для ваших историй.`,
        feature5Title: `Изображение‑в‑видео и видео‑в‑видео`,
        feature5Desc: `Не начинайте с нуля. Загрузите фото, чтобы оживить его (Img2Vid), или мгновенно перерисуйте существующий ролик (Vid2Vid) в стиле аниме или пластилиновой анимации.`,
        feature6Title: `ИИ для e‑commerce и предметной съёмки`,
        feature6Desc: `Мгновенно удаляйте фон, создавайте продуктовые витрины с AI Image Background Changer и делайте маркетинговые материалы, которые конвертят.`,
        feature7Title: 'Контекстно-Осведомлённый Умный ИИ',
        feature7Desc:
            'WeryAI автоматически определяет лица, объекты, сцены, освещение и контекст для точных результатов.',
        feature8Title: 'API и Пакетные Инструменты',
        feature8Desc:
            'Масштабируйте рабочий процесс с помощью инструментов пакетной обработки или интеграции API для высокообъёмной творческой автоматизации.',

        // Раздел 3: How to Use
        howToUseTitle: 'Как создать AI‑видео и изображения за 4 шага',
        step1Title: 'Выберите инструмент',
        step1Desc: `Выберите Text-to-Video, Face Swap или Image Generator.`,
        step2Title: 'Введите промпт или загрузите',
        step2Desc: `Введите текстовое описание или загрузите референс фото/видео.`,
        step3Title: 'Выберите модель',
        step3Desc: `Переключайтесь между Kling, Veo или Flux, чтобы получить нужный стиль.`,
        step4Title: 'Сгенерируйте и экспортируйте',
        step4Desc: `Результат за секунды. Скачивайте в HD/4K без сложных навыков монтажа.`,

        // Раздел 4: FAQ
        faqTitle: 'Часто задаваемые вопросы о WeryAI',
        faqDesc:
            'WeryAI создан для креаторов, маркетологов, дизайнеров, разработчиков и всех, кто хочет быстро и легко превращать идеи в высококачественные визуалы.\nНиже представлены ключевые преимущества, которые делают WeryAI ведущей платформой для создания видео и изображений с ИИ.',
        faq1Question:
            'Почему WeryAI лучше, чем использовать модели по отдельности?',
        faq1Answer: `WeryAI работает как агрегатор. Вместо того чтобы платить отдельные подписки за Kling, Midjourney или Runway, вы получаете доступ ко всем топ‑моделям (Kling 2.5, Flux Pro, Google Veo) в одном кабинете. Это экономит деньги и упрощает рабочий процесс.`,
        faq2Question: 'WeryAI можно использовать бесплатно?',
        faq2Answer: `Да. Мы даём щедрые ежедневные бесплатные кредиты, чтобы вы могли попробовать Text-to-Video, Face Swap и Image Generator. Для старта не нужна банковская карта. Для активного использования и скачивания без водяных знаков доступны гибкие платные планы.`,
        faq3Question:
            'Можно ли использовать Kling AI и Flux на этой платформе?',
        faq3Answer: `Конечно. WeryAI интегрирует последние версии Kling (для реалистичного видео), Flux (для высококачественных изображений) и Google Veo. Мы обновляем библиотеку моделей каждую неделю, чтобы у вас всегда был доступ к передовым возможностям.`,
        faq4Question: 'Как улучшить видео низкого качества?',
        faq4Answer: `Используйте наш AI Video Upscaler. Он автоматически убирает шум/размытие и повышает разрешение до 4K. Отлично подходит для восстановления старых семейных видео или улучшения клипов для соцсетей.`,
        faq5Question: 'Принадлежат ли мне коммерческие права на мои работы?',
        faq5Answer: `Если у вас платный план — да. Вы получаете полные коммерческие права на все материалы, созданные на WeryAI, поэтому их безопасно использовать для монетизации на YouTube, клиентских проектов и маркетинговых кампаний.`,
        faq6Question:
            'Нужны ли навыки редактирования для использования WeryAI?',
        faq6Answer:
            'Опыт не требуется — WeryAI автоматизирует сложное редактирование видео и изображений, чтобы любой мог создавать профессиональные результаты за секунды.',
    },
    pl: {
        // Przyciski
        expandMore: 'Rozwiń więcej treści',
        collapse: 'Zwiń',

        // Sekcja 1: Wprowadzenie
        mainTitle:
            'Bezpłatna, kompleksowa platforma do generowania wideo i obrazów AI',
        mainDesc1:
            'Uzyskaj dostęp do najlepszych modeli AI na świecie w jednym miejscu. Twórz kinowe wideo z Kling AI, Google Veo i Sora, generuj realistyczną sztukę z FLUX i Wan AI lub korzystaj z zaawansowanych narzędzi, takich jak Face Swap i Video Upscaler. Bez przełączania aplikacji — tylko tworzenie.',
        mainDesc2:
            'Korzystaj z najszybszej i najbardziej intuicyjnej platformy tworzenia AI, aby natychmiast generować profesjonalne wideo i obrazy.',

        // Sekcja 2: Why Choose WeryAI
        whyChooseTitle: 'Dlaczego WeryAI to najlepszy generator treści AI?',
        whyChooseDesc:
            'WeryAI został stworzony dla twórców, marketerów, projektantów, deweloperów i każdego, kto chce szybko i łatwo zamieniać pomysły w wysokiej jakości wizualizacje.\nPoniżej najważniejsze przewagi, które czynią WeryAI wiodącą platformą tworzenia wideo i obrazów AI.',

        // 8 funkcji
        feature1Title: 'Dostęp do najlepszych modeli AI (Kling, Flux, Sora)',
        feature1Desc: `Nie płać za wiele subskrypcji. Korzystaj z GPT-4o, Google Veo, Wan 2.5 i Nano Banana w jednym panelu — to prawdziwy agregator modeli AI.`,
        feature2Title: `Narzędzia wideo AI: Face Swap, Lip Sync i Upscale`,
        feature2Desc: `Nie tylko generowanie. Skróć montaż o 90% dzięki AI Video Face Swap, automatycznemu Lip Sync, usuwaniu napisów i 4K Video Upscaler.`,
        feature3Title: `Generowanie wideo i obrazów z tekstu`,
        feature3Desc: `Zamień prompt na realistyczne wideo i obrazy 4K. Obsługa ujęć filmowych, stylu anime i fotorealistycznych portretów.`,
        feature4Title: `AI postacie i transfer ruchu ciała`,
        feature4Desc: `Spraw, by zdjęcia „tańczyły” dzięki Motion Imitation, zamieniaj twarze w wideo lub twórz spójne postacie AI do swoich historii.`,
        feature5Title: `Obraz→wideo i wideo→wideo`,
        feature5Desc: `Nie zaczynaj od zera. Animuj zdjęcie (Img2Vid) lub przestylizuj istniejące wideo (Vid2Vid) na anime lub claymation.`,
        feature6Title: `AI dla e-commerce i fotografii produktowej`,
        feature6Desc: `Usuń tło w sekundę, generuj wizualizacje produktów z AI Image Background Changer i twórz materiały marketingowe, które konwertują.`,
        feature7Title: 'Kontekstowo świadoma inteligentna AI',
        feature7Desc:
            'WeryAI automatycznie wykrywa twarze, obiekty, sceny, światło i kontekst, aby dostarczać precyzyjne wyniki.',
        feature8Title: 'API i narzędzia wsadowe',
        feature8Desc:
            'Skaluj workflow dzięki narzędziom wsadowym i integracji API, aby automatyzować tworzenie na dużą skalę.',

        // Sekcja 3: How to Use
        howToUseTitle: '4 kroki do generowania wideo i obrazów AI',
        step1Title: 'Wybierz narzędzie',
        step1Desc: `Wybierz Text-to-Video, Face Swap lub Image Generator.`,
        step2Title: 'Wpisz prompt lub prześlij materiał',
        step2Desc: `Wpisz opis lub prześlij zdjęcie/wideo jako referencję.`,
        step3Title: 'Wybierz model',
        step3Desc: `Przełączaj się między Kling, Veo i Flux, aby uzyskać pożądany styl.`,
        step4Title: 'Generuj i eksportuj',
        step4Desc: `Wyniki w kilka sekund. Pobieraj w HD/4K bez skomplikowanego montażu.`,

        // Sekcja 4: FAQ
        faqTitle: 'Najczęstsze pytania o WeryAI',
        faqDesc:
            'WeryAI został stworzony dla twórców, marketerów, projektantów, deweloperów i każdego, kto chce szybko i łatwo zamieniać pomysły w wysokiej jakości wizualizacje.\nPoniżej najważniejsze przewagi, które czynią WeryAI wiodącą platformą tworzenia wideo i obrazów AI.',
        faq1Question: 'Dlaczego WeryAI jest lepsze niż korzystanie z modeli osobno?',
        faq1Answer: `WeryAI działa jako agregator. Zamiast płacić oddzielnie za Kling, Midjourney czy Runway, masz dostęp do wszystkich topowych modeli (Kling 2.5, Flux Pro, Google Veo) w jednym panelu. Oszczędzasz czas i pieniądze.`,
        faq2Question: 'Czy WeryAI jest darmowe?',
        faq2Answer: `Tak. Oferujemy hojne, codzienne darmowe kredyty, aby przetestować narzędzia Text-to-Video, Face Swap i Image Generator. Nie potrzebujesz karty, aby zacząć. Dla intensywnego użycia i pobrań bez znaku wodnego są elastyczne plany płatne.`,
        faq3Question: 'Czy mogę korzystać z Kling AI i Flux na tej platformie?',
        faq3Answer: `Oczywiście. WeryAI integruje najnowsze wersje Kling (realistyczne wideo), Flux (wysoka jakość obrazu) i Google Veo. Co tydzień aktualizujemy bibliotekę modeli.`,
        faq4Question: 'Jak poprawić jakość słabych wideo?',
        faq4Answer: `Skorzystaj z naszego AI Video Upscaler. Automatycznie usuwa szumy/rozmycia i podnosi rozdzielczość do 4K. Idealne do starych nagrań rodzinnych lub klipów z social media.`,
        faq5Question: 'Czy posiadam komercyjne prawa do swoich prac?',
        faq5Answer: `Jeśli masz plan płatny — tak. Otrzymujesz pełne prawa komercyjne do wszystkich materiałów wygenerowanych w WeryAI.`,
        faq6Question: 'Czy potrzebuję umiejętności edycji, aby używać WeryAI?',
        faq6Answer:
            'Nie. WeryAI automatyzuje złożoną edycję wideo i obrazów, dzięki czemu każdy może tworzyć profesjonalne efekty w kilka sekund.',
    },
    pt: {
        // Botões
        expandMore: 'Expandir mais',
        collapse: 'Recolher',

        // Seção 1: Introdução do título
        mainTitle:
            'Plataforma gratuita tudo-em-um de geração de vídeo e imagem com IA',
        mainDesc1:
            'Acesse os melhores modelos de IA do mundo em um só lugar. Gere vídeos cinematográficos com Kling AI, Google Veo e Sora, crie arte realista com FLUX e Wan AI, ou use ferramentas avançadas como Face Swap e Video Upscaler. Sem trocar de apps — apenas criação.',
        mainDesc2:
            'Crie vídeos e imagens profissionais instantaneamente com a plataforma de criação de IA mais rápida e intuitiva.',

        // Seção 2: Why Choose WeryAI
        whyChooseTitle:
            'Por que a WeryAI é o melhor gerador de conteúdo com IA?',
        whyChooseDesc:
            'WeryAI é projetado para criadores, profissionais de marketing, designers, desenvolvedores e qualquer pessoa que queira transformar ideias em visuais de alta qualidade — de forma rápida e sem esforço.\nAbaixo estão os pontos fortes principais que fazem do WeryAI uma plataforma líder de criação de vídeo e imagem com IA.',

        // 8 Recursos
        feature1Title: 'Acesse os melhores modelos de IA (Kling, Flux, Sora)',
        feature1Desc: `Pare de pagar várias assinaturas. Use GPT-4o, Google Veo, Wan 2.5 e Nano Banana em um único painel. O agregador definitivo de modelos de IA.`,
        feature2Title: `Ferramentas de vídeo com IA: Face Swap, Lip Sync e Upscale`,
        feature2Desc: `Além da geração. Reduza o tempo de edição em 90% com AI Video Face Swap, Lip Sync automático, Subtitle Eraser e Video Upscaler 4K.`,
        feature3Title: `Texto para vídeo e geração de imagens`,
        feature3Desc: `Transforme prompts de texto em vídeos e imagens 4K realistas. Suporte a cenas cinematográficas, estilos anime e retratos fotorrealistas com os motores generativos mais recentes.`,
        feature4Title: `Transferência de movimento de personagem e corpo com IA`,
        feature4Desc: `Faça fotos “dançarem” com Motion Imitation (estilo Viggle), troque rostos em vídeos sem esforço ou crie personagens de IA consistentes para suas histórias.`,
        feature5Title: `Imagem‑para‑vídeo e vídeo‑para‑vídeo`,
        feature5Desc: `Não comece do zero. Envie uma foto para animá‑la (Img2Vid) ou reestilize um vídeo existente (Vid2Vid) para estilos anime ou claymation instantaneamente.`,
        feature6Title: `IA para e‑commerce e fotografia de produtos`,
        feature6Desc: `Remova fundos instantaneamente, gere showcases de produtos com AI Image Background Changer e crie ativos de marketing que convertem.`,
        feature7Title: 'IA Inteligente Consciente do Contexto',
        feature7Desc:
            'WeryAI detecta automaticamente rostos, objetos, cenas, iluminação e contexto para entregar resultados precisos.',
        feature8Title: 'API e Ferramentas em Lote',
        feature8Desc:
            'Escale seu fluxo de trabalho com ferramentas de processamento em lote ou integração de API para automação criativa de alto volume.',

        // Seção 3: How to Use
        howToUseTitle: 'Como gerar vídeo e imagens com IA em 4 passos',
        step1Title: 'Escolha uma ferramenta',
        step1Desc: `Escolha entre Text-to-Video, Face Swap ou Image Generator.`,
        step2Title: 'Digite o prompt ou faça upload',
        step2Desc: `Digite uma descrição em texto ou envie sua referência de foto/vídeo.`,
        step3Title: 'Escolha o modelo',
        step3Desc: `Alterne entre Kling, Veo ou Flux para obter exatamente o estilo que você quer.`,
        step4Title: 'Gerar e exportar',
        step4Desc: `Resultados em segundos. Baixe em HD/4K sem precisar de habilidades complexas de edição.`,

        // Seção 4: FAQ
        faqTitle: 'Perguntas frequentes sobre a WeryAI',
        faqDesc:
            'WeryAI é projetado para criadores, profissionais de marketing, designers, desenvolvedores e qualquer pessoa que queira transformar ideias em visuais de alta qualidade — de forma rápida e sem esforço.\nAbaixo estão os pontos fortes principais que fazem do WeryAI uma plataforma líder de criação de vídeo e imagem com IA.',
        faq1Question:
            'Por que a WeryAI é melhor do que usar modelos separadamente?',
        faq1Answer: `A WeryAI funciona como um agregador. Em vez de pagar assinaturas separadas para Kling, Midjourney ou Runway, você tem acesso a todos os modelos top (Kling 2.5, Flux Pro, Google Veo) em um único painel. Você economiza e simplifica seu fluxo de trabalho.`,
        faq2Question: 'A WeryAI é gratuita?',
        faq2Answer: `Sim. Oferecemos créditos gratuitos diários generosos para você testar Text-to-Video, Face Swap e Image Generator. Não é necessário cartão de crédito para começar. Para uso intenso e downloads sem marca d’água, há planos pagos flexíveis.`,
        faq3Question: 'Posso usar Kling AI e Flux nesta plataforma?',
        faq3Answer: `Com certeza. A WeryAI integra as versões mais recentes do Kling (para vídeo realista), do Flux (para imagens de alta fidelidade) e do Google Veo. Atualizamos nossa biblioteca de modelos semanalmente para que você tenha sempre acesso ao que há de mais moderno.`,
        faq4Question: 'Como posso melhorar vídeos de baixa qualidade?',
        faq4Answer: `Use nosso AI Video Upscaler. Ele remove automaticamente ruído/desfoque e faz upscale do material para resolução 4K. É perfeito para restaurar vídeos antigos de família ou melhorar clipes para redes sociais.`,
        faq5Question: 'Eu tenho os direitos comerciais das minhas criações?',
        faq5Answer: `Se você estiver em um plano pago, sim. Você tem direitos comerciais completos sobre todos os assets gerados na WeryAI, o que os torna seguros para monetização no YouTube, trabalhos para clientes e campanhas de marketing.`,
        faq6Question: 'Preciso de habilidades de edição para usar WeryAI?',
        faq6Answer:
            'Nenhuma experiência necessária — WeryAI automatiza a edição complexa de vídeo e imagem para que qualquer pessoa possa criar resultados profissionais em segundos.',
    },
    it: {
        // Pulsanti
        expandMore: 'Espandi di più',
        collapse: 'Comprimi',

        // Sezione 1: Introduzione del titolo
        mainTitle:
            'Piattaforma gratuita tutto-in-uno per generare video e immagini con IA',
        mainDesc1:
            'Accedi ai migliori modelli di IA del mondo in un unico posto. Genera video cinematografici con Kling AI, Google Veo e Sora, crea arte realistica con FLUX e Wan AI, oppure usa strumenti avanzati come Face Swap e Video Upscaler. Niente cambio di app: solo creazione.',
        mainDesc2:
            'Crea video e immagini professionali istantaneamente con la piattaforma di creazione IA più veloce e intuitiva.',

        // Sezione 2: Why Choose WeryAI
        whyChooseTitle:
            'Perché WeryAI è il miglior generatore di contenuti con IA?',
        whyChooseDesc:
            'WeryAI è progettato per creatori, marketer, designer, sviluppatori e chiunque voglia trasformare le idee in visual di alta qualità — rapidamente e senza sforzo.\nDi seguito sono riportati i punti di forza principali che rendono WeryAI una piattaforma leader nella creazione di video e immagini con IA.',

        // 8 Funzionalità
        feature1Title: 'Accedi ai migliori modelli di IA (Kling, Flux, Sora)',
        feature1Desc: `Smetti di pagare più abbonamenti. Usa GPT-4o, Google Veo, Wan 2.5 e Nano Banana in un’unica dashboard. L’aggregatore definitivo di modelli di IA.`,
        feature2Title: `Strumenti video con IA: Face Swap, Lip Sync e Upscale`,
        feature2Desc: `Oltre la generazione. Riduci il tempo di editing del 90% con AI Video Face Swap, Lip Sync automatico, Subtitle Eraser e Video Upscaler 4K.`,
        feature3Title: `Testo in video e generazione di immagini`,
        feature3Desc: `Trasforma prompt di testo in video e immagini 4K realistici. Supporta riprese cinematiche, stili anime e ritratti fotorealistici grazie ai motori generativi più recenti.`,
        feature4Title: `Trasferimento del movimento di personaggi e corpo con IA`,
        feature4Desc: `Fai “danzare” le foto con Motion Imitation (stile Viggle), scambia i volti nei video in modo fluido o crea personaggi IA coerenti per le tue storie.`,
        feature5Title: `Immagine‑in‑video e video‑in‑video`,
        feature5Desc: `Non partire da zero. Carica una foto per animarla (Img2Vid) oppure re‑stile un filmato esistente (Vid2Vid) in stile anime o claymation all’istante.`,
        feature6Title: `IA per e‑commerce e fotografia di prodotto`,
        feature6Desc: `Rimuovi subito gli sfondi, genera showcase di prodotto con AI Image Background Changer e crea asset marketing che convertono.`,
        feature7Title: 'IA Intelligente Consapevole del Contesto',
        feature7Desc:
            'WeryAI rileva automaticamente volti, oggetti, scene, illuminazione e contesto per fornire risultati precisi.',
        feature8Title: 'API e Strumenti Batch',
        feature8Desc:
            'Scala il tuo flusso di lavoro con strumenti di elaborazione batch o integrazione API per automazione creativa ad alto volume.',

        // Sezione 3: How to Use
        howToUseTitle: 'Come generare video e immagini IA in 4 passaggi',
        step1Title: 'Scegli uno strumento',
        step1Desc: `Scegli tra Text-to-Video, Face Swap o Image Generator.`,
        step2Title: 'Inserisci un prompt o carica',
        step2Desc: `Scrivi una descrizione testuale o carica il riferimento foto/video.`,
        step3Title: 'Scegli il modello',
        step3Desc: `Passa da Kling, Veo o Flux per ottenere lo stile esatto che vuoi.`,
        step4Title: 'Genera ed esporta',
        step4Desc: `Risultati in pochi secondi. Scarica in HD/4K senza competenze di editing complesse.`,

        // Sezione 4: FAQ
        faqTitle: 'Domande frequenti su WeryAI',
        faqDesc:
            'WeryAI è progettato per creatori, marketer, designer, sviluppatori e chiunque voglia trasformare le idee in visual di alta qualità — rapidamente e senza sforzo.\nDi seguito sono riportati i punti di forza principali che rendono WeryAI una piattaforma leader nella creazione di video e immagini con IA.',
        faq1Question:
            'Perché WeryAI è meglio che usare i modelli separatamente?',
        faq1Answer: `WeryAI funziona come un aggregatore. Invece di pagare abbonamenti separati per Kling, Midjourney o Runway, hai accesso a tutti i modelli top (Kling 2.5, Flux Pro, Google Veo) in un’unica dashboard. Risparmi e semplifichi il workflow.`,
        faq2Question: 'WeryAI è gratuito?',
        faq2Answer: `Sì. Offriamo generosi crediti gratuiti giornalieri per provare Text-to-Video, Face Swap e Image Generator. Non serve carta di credito per iniziare. Per uso intensivo e download senza watermark, sono disponibili piani a pagamento flessibili.`,
        faq3Question: 'Posso usare Kling AI e Flux su questa piattaforma?',
        faq3Answer: `Assolutamente. WeryAI integra le versioni più recenti di Kling (per video realistici), Flux (per immagini ad alta fedeltà) e Google Veo. Aggiorniamo la libreria dei modelli ogni settimana, così hai sempre accesso al meglio.`,
        faq4Question: 'Come posso migliorare video di bassa qualità?',
        faq4Answer: `Usa il nostro AI Video Upscaler. Rimuove automaticamente rumore/sfocatura e fa upscale del filmato fino alla risoluzione 4K. È perfetto per restaurare vecchi video di famiglia o migliorare clip per i social.`,
        faq5Question: 'Possiedo i diritti commerciali delle mie creazioni?',
        faq5Answer: `Se hai un piano a pagamento, sì. Possiedi pieni diritti commerciali su tutti gli asset generati su WeryAI, quindi sono sicuri per monetizzazione YouTube, lavori per clienti e campagne marketing.`,
        faq6Question: 'Ho bisogno di competenze di editing per usare WeryAI?',
        faq6Answer:
            "Nessuna esperienza necessaria — WeryAI automatizza l'editing complesso di video e immagini così che chiunque possa creare risultati professionali in pochi secondi.",
    },
    ar: {
        // الأزرار
        expandMore: 'عرض المزيد',
        collapse: 'طي',

        // القسم 1: مقدمة العنوان
        mainTitle: 'منصة مجانية شاملة لتوليد الفيديو والصور بالذكاء الاصطناعي',
        mainDesc1:
            'ادخل إلى أفضل نماذج الذكاء الاصطناعي في العالم في مكان واحد. أنشئ فيديوهات سينمائية باستخدام Kling AI وGoogle Veo وSora، واصنع فنًا واقعيًا باستخدام FLUX وWan AI، أو استخدم أدوات متقدمة مثل تبديل الوجوه ومحسّن الفيديو. بلا تنقّل بين التطبيقات — فقط إبداع خالص.',
        mainDesc2:
            'أنشئ مقاطع فيديو وصورًا احترافية فورًا مع أسرع وأكثر منصة إنشاء بالذكاء الاصطناعي سهولة في الاستخدام.',

        // القسم 2: لماذا تختار WeryAI
        whyChooseTitle: 'لماذا WeryAI هو أفضل مولّد محتوى بالذكاء الاصطناعي؟',
        whyChooseDesc:
            'صُمم WeryAI للمبدعين والمسوقين والمصممين والمطورين وأي شخص يريد تحويل الأفكار إلى صور عالية الجودة - بسرعة وبدون جهد.\nفيما يلي نقاط القوة الأساسية التي تجعل WeryAI منصة رائدة لإنشاء الفيديو والصور بالذكاء الاصطناعي.',

        // 8 ميزات
        feature1Title:
            'الوصول إلى أفضل نماذج الذكاء الاصطناعي (Kling, Flux, Sora)',
        feature1Desc: `توقّف عن دفع اشتراكات متعددة. استخدم GPT-4o وGoogle Veo وWan 2.5 وNano Banana كلّها في لوحة تحكم واحدة. مجمّع نماذج الذكاء الاصطناعي الأقوى.`,
        feature2Title: `أدوات فيديو بالذكاء الاصطناعي: تبديل الوجوه، مزامنة الشفاه، ورفع الدقة`,
        feature2Desc: `أكثر من مجرد توليد. قلّل وقت التحرير بنسبة 90% عبر AI Video Face Swap وLip Sync التلقائي وSubtitle Eraser و4K Video Upscaler.`,
        feature3Title: `تحويل النص إلى فيديو وتوليد الصور`,
        feature3Desc: `حوّل أوامر النص إلى فيديوهات وصور 4K واقعية. دعم لقطات سينمائية وأنماط أنيمي وبورتريهات فوتوريالية باستخدام أحدث المحركات التوليدية.`,
        feature4Title: `نقل حركة الشخصية والجسم بالذكاء الاصطناعي`,
        feature4Desc: `اجعل الصور “ترقص” عبر Motion Imitation (أسلوب Viggle)، وبدّل الوجوه في الفيديو بسلاسة، أو أنشئ شخصيات ذكاء اصطناعي متسقة لقصصك.`,
        feature5Title: `صورة‑إلى‑فيديو وفيديو‑إلى‑فيديو`,
        feature5Desc: `لا تبدأ من الصفر. ارفع صورة لتحريكها (Img2Vid) أو أعد أسلوب فيديو موجود (Vid2Vid) إلى أنيمي أو claymation فورًا.`,
        feature6Title: `ذكاء اصطناعي للتجارة الإلكترونية وتصوير المنتجات`,
        feature6Desc: `أزل الخلفيات فورًا، وأنشئ عروض منتجات عبر AI Image Background Changer، واصنع مواد تسويقية تزيد التحويل.`,
        feature7Title: 'ذكاء اصطناعي ذكي يدرك السياق',
        feature7Desc:
            'يكتشف WeryAI تلقائيًا الوجوه والأشياء والمشاهد والإضاءة والسياق لتقديم نتائج دقيقة.',
        feature8Title: 'API وأدوات المعالجة الدفعية',
        feature8Desc:
            'وسّع سير عملك باستخدام أدوات المعالجة الدفعية أو تكامل API للأتمتة الإبداعية بحجم كبير.',

        // القسم 3: كيفية الاستخدام
        howToUseTitle: 'كيفية إنشاء فيديو وصور بالذكاء الاصطناعي في 4 خطوات',
        step1Title: 'اختر أداة',
        step1Desc: `اختر من Text-to-Video أو Face Swap أو Image Generator.`,
        step2Title: 'اكتب الوصف أو ارفع الملف',
        step2Desc: `اكتب وصفًا نصيًا أو ارفع مرجعك من صورة/فيديو.`,
        step3Title: 'اختر النموذج',
        step3Desc: `بدّل بين Kling أو Veo أو Flux للحصول على الأسلوب الذي تريده بدقة.`,
        step4Title: 'أنشئ وصدّر',
        step4Desc: `احصل على النتائج خلال ثوانٍ. نزّل بجودة HD/4K دون مهارات تحرير معقدة.`,

        // القسم 4: الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة حول WeryAI',
        faqDesc:
            'صُمم WeryAI للمبدعين والمسوقين والمصممين والمطورين وأي شخص يريد تحويل الأفكار إلى صور عالية الجودة - بسرعة وبدون جهد.\nفيما يلي نقاط القوة الأساسية التي تجعل WeryAI منصة رائدة لإنشاء الفيديو والصور بالذكاء الاصطناعي.',
        faq1Question: 'لماذا WeryAI أفضل من استخدام النماذج بشكل منفصل؟',
        faq1Answer: `يعمل WeryAI كمجمّع. بدلًا من دفع اشتراكات منفصلة لـ Kling أو Midjourney أو Runway، ستحصل على الوصول إلى أفضل النماذج (Kling 2.5 وFlux Pro وGoogle Veo) من خلال لوحة تحكم واحدة. هذا يوفر المال ويبسط سير عملك.`,
        faq2Question: 'هل يمكن استخدام WeryAI مجانًا؟',
        faq2Answer: `نعم. نقدم رصيدًا مجانيًا يوميًا سخياً يتيح لك تجربة أدوات Text-to-Video وFace Swap وImage Generator. لا حاجة لبطاقة ائتمان للبدء. وللاستخدام المكثف والتنزيلات بدون علامة مائية، تتوفر خطط مدفوعة مرنة.`,
        faq3Question: 'هل يمكنني استخدام Kling AI وFlux على هذه المنصة؟',
        faq3Answer: `بالتأكيد. يدمج WeryAI أحدث إصدارات Kling (لفيديو واقعي) وFlux (لصور عالية الدقة) وGoogle Veo. نقوم بتحديث مكتبة النماذج أسبوعيًا لتبقى دائمًا على أحدث ما توصلت إليه التقنية.`,
        faq4Question: 'كيف يمكنني تحسين الفيديوهات منخفضة الجودة؟',
        faq4Answer: `استخدم AI Video Upscaler لدينا. يزيل الضوضاء/التمويه تلقائيًا ويرفع دقة الفيديو إلى 4K. مثالي لاستعادة فيديوهات عائلية قديمة أو تحسين مقاطع وسائل التواصل الاجتماعي.`,
        faq5Question: 'هل أمتلك الحقوق التجارية لأعمالي؟',
        faq5Answer: `إذا كنت على خطة مدفوعة، نعم. تمتلك حقوقًا تجارية كاملة لجميع الأصول التي يتم إنشاؤها على WeryAI، ما يجعلها آمنة لتحقيق الدخل على YouTube، وأعمال العملاء، والحملات التسويقية.`,
        faq6Question: 'هل أحتاج مهارات تحرير لاستخدام WeryAI؟',
        faq6Answer:
            'لا حاجة لأي خبرة — يقوم WeryAI بأتمتة تحرير الفيديو والصور المعقد حتى يتمكن أي شخص من إنشاء نتائج احترافية في ثوانٍ.',
    },
    // 泰语
    th: {
        // ปุ่ม
        expandMore: 'ขยายเพิ่มเติม',
        collapse: 'ยุบ',

        // ส่วนที่ 1: แนะนำหัวข้อ
        mainTitle: 'แพลตฟอร์มสร้างวิดีโอและภาพ AI ฟรีครบวงจร',
        mainDesc1:
            'เข้าถึงโมเดล AI ที่ดีที่สุดในโลกในที่เดียว สร้างวิดีโอแบบภาพยนตร์ด้วย Kling AI, Google Veo และ Sora สร้างงานศิลปะที่สมจริงด้วย FLUX และ Wan AI หรือใช้เครื่องมือขั้นสูงอย่าง Face Swap และ Video Upscaler ไม่ต้องสลับแอป—เพียงสร้างสรรค์อย่างเดียว',
        mainDesc2:
            'สร้างวิดีโอและภาพระดับมืออาชีพทันทีด้วยแพลตฟอร์มสร้าง AI ที่เร็วและใช้งานง่ายที่สุด',

        // ส่วนที่ 2: ทำไมต้องเลือก WeryAI
        whyChooseTitle: 'ทำไม WeryAI ถึงเป็นตัวสร้างเนื้อหา AI ที่ดีที่สุด?',
        whyChooseDesc:
            'WeryAI ออกแบบมาสำหรับครีเอเตอร์ นักการตลาด นักออกแบบ นักพัฒนา และทุกคนที่ต้องการเปลี่ยนไอเดียเป็นภาพคุณภาพสูงอย่างรวดเร็วและง่ายดาย\nด้านล่างคือจุดแข็งหลักที่ทำให้ WeryAI เป็นแพลตฟอร์มสร้างวิดีโอและภาพ AI ชั้นนำ',

        // 8 คุณสมบัติ
        feature1Title: 'เข้าถึงโมเดล AI ชั้นนำ (Kling, Flux, Sora)',
        feature1Desc: `หยุดจ่ายค่าสมัครหลายรายการ ใช้ GPT-4o, Google Veo, Wan 2.5 และ Nano Banana ทั้งหมดในแดชบอร์ดเดียว ตัวรวมโมเดล AI ที่ดีที่สุด`,
        feature2Title: `เครื่องมือวิดีโอ AI: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `มากกว่าการสร้าง ลดเวลาตัดต่อ 90% ด้วย AI Video Face Swap, Lip Sync อัตโนมัติ, Subtitle Eraser และ 4K Video Upscaler`,
        feature3Title: `ข้อความเป็นวิดีโอและการสร้างภาพ`,
        feature3Desc: `เปลี่ยนข้อความเป็นวิดีโอและภาพ 4K ที่สมจริง รองรับช็อตแบบภาพยนตร์ สไตล์อนิเมะ และภาพบุคคลที่สมจริงด้วยเอนจิ้นสร้างล่าสุด`,
        feature4Title: `AI Character & Body Motion Transfer`,
        feature4Desc: `ทำให้รูปภาพ "เต้น" ด้วย Motion Imitation (สไตล์ Viggle) สลับใบหน้าในวิดีโออย่างราบรื่น หรือสร้างตัวละคร AI ที่สม่ำเสมอสำหรับเรื่องราวของคุณ`,
        feature5Title: `ภาพเป็นวิดีโอ & วิดีโอเป็นวิดีโอ`,
        feature5Desc: `ไม่ต้องเริ่มจากศูนย์ อัปโหลดรูปภาพเพื่อทำให้เคลื่อนไหว (Img2Vid) หรือเปลี่ยนสไตล์ฟุตเทจที่มีอยู่ (Vid2Vid) เป็นสไตล์อนิเมะหรือ claymation ทันที`,
        feature6Title: `AI สำหรับอีคอมเมิร์ซและถ่ายภาพสินค้า`,
        feature6Desc: `ลบพื้นหลังทันที สร้างโชว์เคสสินค้าด้วย AI Image Background Changer และสร้างสื่อการตลาดที่แปลงยอด`,
        feature7Title: 'AI อัจฉริยะที่เข้าใจบริบท',
        feature7Desc:
            'WeryAI ตรวจจับใบหน้า วัตถุ ฉาก แสง และบริบทโดยอัตโนมัติเพื่อให้ผลลัพธ์ที่แม่นยำ',
        feature8Title: 'API และเครื่องมือแบทช์',
        feature8Desc:
            'ขยายเวิร์กโฟลว์ด้วยเครื่องมือประมวลผลแบทช์หรือการรวม API สำหรับการสร้างสรรค์อัตโนมัติปริมาณมาก',

        // ส่วนที่ 3: วิธีใช้
        howToUseTitle: 'วิธีสร้างวิดีโอและภาพ AI ใน 4 ขั้นตอน',
        step1Title: 'เลือกเครื่องมือ',
        step1Desc: `เลือกจาก Text-to-Video, Face Swap หรือ Image Generator`,
        step2Title: 'ป้อนข้อความหรืออัปโหลด',
        step2Desc: `พิมพ์คำอธิบายหรืออัปโหลดรูปภาพ/วิดีโออ้างอิง`,
        step3Title: 'เลือกโมเดล',
        step3Desc: `สลับระหว่าง Kling, Veo หรือ Flux เพื่อให้ได้สไตล์ที่ต้องการ`,
        step4Title: 'สร้างและส่งออก',
        step4Desc: `ได้ผลลัพธ์ในไม่กี่วินาที ดาวน์โหลดในรูปแบบ HD/4K โดยไม่ต้องมีทักษะตัดต่อซับซ้อน`,

        // ส่วนที่ 4: FAQ
        faqTitle: 'คำถามที่พบบ่อยเกี่ยวกับ WeryAI',
        faqDesc:
            'WeryAI ออกแบบมาสำหรับครีเอเตอร์ นักการตลาด นักออกแบบ นักพัฒนา และทุกคนที่ต้องการเปลี่ยนไอเดียเป็นภาพคุณภาพสูงอย่างรวดเร็วและง่ายดาย\nด้านล่างคือจุดแข็งหลักที่ทำให้ WeryAI เป็นแพลตฟอร์มสร้างวิดีโอและภาพ AI ชั้นนำ',
        faq1Question: 'ทำไม WeryAI ดีกว่าการใช้โมเดลแยกกัน?',
        faq1Answer: `WeryAI ทำหน้าที่เป็นตัวรวม แทนที่จะจ่ายค่าสมัครแยกสำหรับ Kling, Midjourney หรือ Runway คุณสามารถเข้าถึงโมเดลชั้นนำทั้งหมด (Kling 2.5, Flux Pro, Google Veo) ในแดชบอร์ดเดียว ประหยัดเงินและทำให้เวิร์กโฟลว์ราบรื่น`,
        faq2Question: 'WeryAI ใช้ฟรีได้ไหม?',
        faq2Answer: `ได้ เรามีเครดิตฟรีรายวันมากมายให้คุณทดลองใช้เครื่องมือ Text-to-Video, Face Swap และ Image Generator ไม่ต้องใช้บัตรเครดิตในการเริ่มต้น สำหรับการใช้งานหนักและดาวน์โหลดไม่มีลายน้ำ มีแผนชำระเงินที่ยืดหยุ่น`,
        faq3Question: 'ฉันสามารถใช้ Kling AI และ Flux บนแพลตฟอร์มนี้ได้ไหม?',
        faq3Answer: `แน่นอน WeryAI รวมเวอร์ชันล่าสุดของ Kling (สำหรับวิดีโอที่สมจริง), Flux (สำหรับภาพความละเอียดสูง) และ Google Veo เราอัปเดตไลบรารีโมเดลทุกสัปดาห์เพื่อให้คุณเข้าถึงเทคโนโลยีล่าสุดเสมอ`,
        faq4Question: 'ฉันจะปรับปรุงวิดีโอคุณภาพต่ำได้อย่างไร?',
        faq4Answer: `ใช้ AI Video Upscaler ของเรา มันจะลบ noise/blur โดยอัตโนมัติและอัปสเกลฟุตเทจเป็นความละเอียด 4K เหมาะสำหรับการกู้คืนวิดีโอครอบครัวเก่าหรือปรับปรุงคลิปโซเชียลมีเดีย`,
        faq5Question: 'ฉันเป็นเจ้าของสิทธิ์เชิงพาณิชย์ในผลงานของฉันไหม?',
        faq5Answer: `หากคุณใช้แผนชำระเงิน ใช่ คุณเป็นเจ้าของสิทธิ์เชิงพาณิชย์เต็มรูปแบบสำหรับสินทรัพย์ทั้งหมดที่สร้างบน WeryAI ทำให้ปลอดภัยสำหรับการสร้างรายได้บน YouTube งานลูกค้า และแคมเปญการตลาด`,
        faq6Question: 'ฉันต้องมีทักษะตัดต่อเพื่อใช้ WeryAI ไหม?',
        faq6Answer:
            'ไม่ต้องมีประสบการณ์—WeryAI ทำให้การตัดต่อวิดีโอและภาพที่ซับซ้อนเป็นอัตโนมัติ เพื่อให้ทุกคนสามารถสร้างผลลัพธ์ระดับมืออาชีพในไม่กี่วินาที',
    },
    // 丹麦语
    da: {
        // Knapper
        expandMore: 'Udvid mere',
        collapse: 'Skjul',

        // Sektion 1: Titelintroduktion
        mainTitle: 'Gratis alt-i-én AI video- og billedgenereringsplatform',
        mainDesc1:
            'Få adgang til verdens bedste AI-modeller ét sted. Generer cinematiske videoer med Kling AI, Google Veo og Sora, skab realistisk kunst med FLUX og Wan AI, eller brug avancerede værktøjer som Face Swap og Video Upscaler. Ingen app-skift—kun ren kreativitet.',
        mainDesc2:
            'Opret professionelle videoer og billeder øjeblikkeligt med den hurtigste og mest intuitive AI-skabelsesplatform.',

        // Sektion 2: Hvorfor vælge WeryAI
        whyChooseTitle: 'Hvorfor er WeryAI den bedste AI-indholdsgenerator?',
        whyChooseDesc:
            'WeryAI er designet til kreatører, marketingfolk, designere, udviklere og alle, der ønsker at omdanne idéer til visuals i høj kvalitet—hurtigt og ubesværet.\nNedenfor er de kernestyrker, der gør WeryAI til en førende AI video- og billedskabelsesplatform.',

        // 8 Funktioner
        feature1Title: 'Adgang til top AI-modeller (Kling, Flux, Sora)',
        feature1Desc: `Stop med at betale for flere abonnementer. Brug GPT-4o, Google Veo, Wan 2.5 og Nano Banana i ét dashboard. Den ultimative AI-modelaggregator.`,
        feature2Title: `AI-videoværktøjer: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Mere end generering. Reducer redigeringstiden med 90% med AI Video Face Swap, auto Lip Sync, Subtitle Eraser og 4K Video Upscaler.`,
        feature3Title: `Tekst til video og billedgenerering`,
        feature3Desc: `Omdann tekstprompter til realistiske 4K-videoer og billeder. Understøtter cinematiske optagelser, anime-stilarter og fotorealistiske portrætter med de nyeste generative motorer.`,
        feature4Title: `AI-karakter og kropsbevægelsesoverførsel`,
        feature4Desc: `Få fotos til at "danse" med Motion Imitation (Viggle-stil), skift ansigter i videoer problemfrit, eller skab konsistente AI-karakterer til dine historier.`,
        feature5Title: `Billede-til-video & Video-til-video`,
        feature5Desc: `Start ikke fra bunden. Upload et foto for at animere det (Img2Vid) eller restyle eksisterende optagelser (Vid2Vid) til anime- eller claymation-stilarter øjeblikkeligt.`,
        feature6Title: `AI til e-handel og produktfotografering`,
        feature6Desc: `Fjern baggrunde øjeblikkeligt, generer produktshowcases med AI Image Background Changer, og skab marketingaktiver, der konverterer.`,
        feature7Title: 'Kontekstbevidst intelligent AI',
        feature7Desc:
            'WeryAI registrerer automatisk ansigter, objekter, scener, belysning og kontekst for at levere præcise resultater.',
        feature8Title: 'API og batchværktøjer',
        feature8Desc:
            'Skaler din arbejdsgang med batchbehandlingsværktøjer eller API-integration til kreativ automatisering i stor skala.',

        // Sektion 3: Sådan bruges
        howToUseTitle: 'Sådan genererer du AI-video og billeder i 4 trin',
        step1Title: 'Vælg et værktøj',
        step1Desc: `Vælg mellem Text-to-Video, Face Swap eller Image Generator.`,
        step2Title: 'Indtast prompt eller upload',
        step2Desc: `Skriv en tekstbeskrivelse eller upload din foto/video-reference.`,
        step3Title: 'Vælg model',
        step3Desc: `Skift mellem Kling, Veo eller Flux for at få den præcise stil, du ønsker.`,
        step4Title: 'Generer og eksporter',
        step4Desc: `Få resultater på sekunder. Download i HD/4K uden komplekse redigeringsfærdigheder.`,

        // Sektion 4: FAQ
        faqTitle: 'Ofte stillede spørgsmål om WeryAI',
        faqDesc:
            'WeryAI er designet til kreatører, marketingfolk, designere, udviklere og alle, der ønsker at omdanne idéer til visuals i høj kvalitet—hurtigt og ubesværet.\nNedenfor er de kernestyrker, der gør WeryAI til en førende AI video- og billedskabelsesplatform.',
        faq1Question: 'Hvorfor er WeryAI bedre end at bruge modeller separat?',
        faq1Answer: `WeryAI fungerer som en aggregator. I stedet for at betale separate abonnementer til Kling, Midjourney eller Runway får du adgang til alle topmodeller (Kling 2.5, Flux Pro, Google Veo) i ét dashboard. Det sparer penge og strømliner din arbejdsgang.`,
        faq2Question: 'Er WeryAI gratis at bruge?',
        faq2Answer: `Ja. Vi tilbyder generøse daglige gratis kreditter, så du kan teste vores Text-to-Video, Face Swap og Image Generator-værktøjer. Intet kreditkort er nødvendigt for at starte. Til intensiv brug og downloads uden vandmærke er der fleksible betalte planer tilgængelige.`,
        faq3Question: 'Kan jeg bruge Kling AI og Flux på denne platform?',
        faq3Answer: `Absolut. WeryAI integrerer de nyeste versioner af Kling (til realistisk video), Flux (til billeder i høj kvalitet) og Google Veo. Vi opdaterer vores modelbibliotek ugentligt, så du altid har adgang til det nyeste.`,
        faq4Question: 'Hvordan kan jeg forbedre mine videoer i lav kvalitet?',
        faq4Answer: `Brug vores AI Video Upscaler. Den fjerner automatisk støj/sløring og opskalerer optagelser til 4K-opløsning. Den er perfekt til at gendanne gamle familievideoer eller forbedre sociale medieklip.`,
        faq5Question: 'Ejer jeg de kommercielle rettigheder til mine kreationer?',
        faq5Answer: `Hvis du er på en betalt plan, ja. Du ejer fulde kommercielle rettigheder til alle aktiver genereret på WeryAI, hvilket gør dem sikre til YouTube-monetarisering, klientarbejde og marketingkampagner.`,
        faq6Question: 'Har jeg brug for redigeringsfærdigheder for at bruge WeryAI?',
        faq6Answer:
            'Ingen erfaring nødvendig—WeryAI automatiserer kompleks video- og billedredigering, så alle kan skabe professionelle resultater på sekunder.',
    },
    // 挪威语
    no: {
        // Knapper
        expandMore: 'Utvid mer',
        collapse: 'Skjul',

        // Seksjon 1: Tittelintroduksjon
        mainTitle: 'Gratis alt-i-ett AI video- og bildegenereringsplattform',
        mainDesc1:
            'Få tilgang til verdens beste AI-modeller på ett sted. Generer filmatiske videoer med Kling AI, Google Veo og Sora, skap realistisk kunst med FLUX og Wan AI, eller bruk avanserte verktøy som Face Swap og Video Upscaler. Ingen app-bytte—bare ren kreativitet.',
        mainDesc2:
            'Lag profesjonelle videoer og bilder umiddelbart med den raskeste og mest intuitive AI-skapelsesplattformen.',

        // Seksjon 2: Hvorfor velge WeryAI
        whyChooseTitle: 'Hvorfor er WeryAI den beste AI-innholdsgeneratoren?',
        whyChooseDesc:
            'WeryAI er designet for skapere, markedsførere, designere, utviklere og alle som ønsker å gjøre ideer om til høykvalitets visuals—raskt og uanstrengt.\nNedenfor er kjernestyrken som gjør WeryAI til en ledende AI video- og bildeskapelsesplattform.',

        // 8 Funksjoner
        feature1Title: 'Tilgang til topp AI-modeller (Kling, Flux, Sora)',
        feature1Desc: `Slutt å betale for flere abonnementer. Bruk GPT-4o, Google Veo, Wan 2.5 og Nano Banana i ett dashbord. Den ultimate AI-modellaggregatoren.`,
        feature2Title: `AI-videoverktøy: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Mer enn generering. Reduser redigeringstiden med 90% med AI Video Face Swap, auto Lip Sync, Subtitle Eraser og 4K Video Upscaler.`,
        feature3Title: `Tekst til video og bildegenerering`,
        feature3Desc: `Gjør tekstprompter til realistiske 4K-videoer og bilder. Støtter filmatiske opptak, anime-stiler og fotorealistiske portretter med de nyeste generative motorene.`,
        feature4Title: `AI-karakter og kroppsbevegelsesoverføring`,
        feature4Desc: `Få bilder til å "danse" med Motion Imitation (Viggle-stil), bytt ansikter i videoer sømløst, eller skap konsistente AI-karakterer for historiene dine.`,
        feature5Title: `Bilde-til-video & Video-til-video`,
        feature5Desc: `Start ikke fra bunnen. Last opp et bilde for å animere det (Img2Vid) eller restyle eksisterende opptak (Vid2Vid) til anime- eller claymation-stiler umiddelbart.`,
        feature6Title: `AI for e-handel og produktfotografering`,
        feature6Desc: `Fjern bakgrunner umiddelbart, generer produktshowcases med AI Image Background Changer, og skap markedsføringsressurser som konverterer.`,
        feature7Title: 'Kontekstbevisst intelligent AI',
        feature7Desc:
            'WeryAI oppdager automatisk ansikter, objekter, scener, belysning og kontekst for å levere presise resultater.',
        feature8Title: 'API og batchverktøy',
        feature8Desc:
            'Skaler arbeidsflyten din med batchbehandlingsverktøy eller API-integrasjon for kreativ automatisering i stor skala.',

        // Seksjon 3: Slik bruker du
        howToUseTitle: 'Slik genererer du AI-video og bilder i 4 trinn',
        step1Title: 'Velg et verktøy',
        step1Desc: `Velg mellom Text-to-Video, Face Swap eller Image Generator.`,
        step2Title: 'Skriv inn prompt eller last opp',
        step2Desc: `Skriv en tekstbeskrivelse eller last opp foto/video-referansen din.`,
        step3Title: 'Velg modell',
        step3Desc: `Bytt mellom Kling, Veo eller Flux for å få den eksakte stilen du ønsker.`,
        step4Title: 'Generer og eksporter',
        step4Desc: `Få resultater på sekunder. Last ned i HD/4K uten komplekse redigeringsferdigheter.`,

        // Seksjon 4: FAQ
        faqTitle: 'Ofte stilte spørsmål om WeryAI',
        faqDesc:
            'WeryAI er designet for skapere, markedsførere, designere, utviklere og alle som ønsker å gjøre ideer om til høykvalitets visuals—raskt og uanstrengt.\nNedenfor er kjernestyrken som gjør WeryAI til en ledende AI video- og bildeskapelsesplattform.',
        faq1Question: 'Hvorfor er WeryAI bedre enn å bruke modeller separat?',
        faq1Answer: `WeryAI fungerer som en aggregator. I stedet for å betale separate abonnementer for Kling, Midjourney eller Runway får du tilgang til alle toppmodeller (Kling 2.5, Flux Pro, Google Veo) i ett dashbord. Det sparer penger og effektiviserer arbeidsflyten din.`,
        faq2Question: 'Er WeryAI gratis å bruke?',
        faq2Answer: `Ja. Vi tilbyr generøse daglige gratis kreditter slik at du kan teste våre Text-to-Video, Face Swap og Image Generator-verktøy. Ingen kredittkort er nødvendig for å starte. For intensiv bruk og nedlastinger uten vannmerke er det fleksible betalte planer tilgjengelig.`,
        faq3Question: 'Kan jeg bruke Kling AI og Flux på denne plattformen?',
        faq3Answer: `Absolutt. WeryAI integrerer de nyeste versjonene av Kling (for realistisk video), Flux (for bilder med høy kvalitet) og Google Veo. Vi oppdaterer modellbiblioteket vårt ukentlig slik at du alltid har tilgang til det nyeste.`,
        faq4Question: 'Hvordan kan jeg forbedre videoer med lav kvalitet?',
        faq4Answer: `Bruk vår AI Video Upscaler. Den fjerner automatisk støy/uskarphet og oppskalerer opptak til 4K-oppløsning. Den er perfekt for å gjenopprette gamle familievideoer eller forbedre sosiale medieklipp.`,
        faq5Question: 'Eier jeg de kommersielle rettighetene til kreasjonene mine?',
        faq5Answer: `Hvis du er på en betalt plan, ja. Du eier fulle kommersielle rettigheter til alle ressurser generert på WeryAI, noe som gjør dem trygge for YouTube-monetarisering, klientarbeid og markedsføringskampanjer.`,
        faq6Question: 'Trenger jeg redigeringsferdigheter for å bruke WeryAI?',
        faq6Answer:
            'Ingen erfaring nødvendig—WeryAI automatiserer kompleks video- og bilderedigering slik at alle kan skape profesjonelle resultater på sekunder.',
    },
    // 荷兰语
    nl: {
        // Knoppen
        expandMore: 'Meer uitvouwen',
        collapse: 'Inklappen',

        // Sectie 1: Titelintroductie
        mainTitle: 'Gratis alles-in-één AI video- en afbeeldinggeneratieplatform',
        mainDesc1:
            'Krijg toegang tot de beste AI-modellen ter wereld op één plek. Genereer cinematische videos met Kling AI, Google Veo en Sora, creëer realistische kunst met FLUX en Wan AI, of gebruik geavanceerde tools zoals Face Swap en Video Upscaler. Geen app-wisseling—alleen pure creatie.',
        mainDesc2:
            'Maak direct professionele videos en afbeeldingen met het snelste en meest intuïtieve AI-creatieplatform.',

        // Sectie 2: Waarom WeryAI kiezen
        whyChooseTitle: 'Waarom is WeryAI de beste AI-contentgenerator?',
        whyChooseDesc:
            'WeryAI is ontworpen voor makers, marketeers, ontwerpers, ontwikkelaars en iedereen die ideeën snel en moeiteloos wil omzetten in hoogwaardige visuals.\nHieronder staan de kernsterktes die WeryAI tot een toonaangevend AI video- en afbeeldingcreatieplatform maken.',

        // 8 Functies
        feature1Title: 'Toegang tot top AI-modellen (Kling, Flux, Sora)',
        feature1Desc: `Stop met betalen voor meerdere abonnementen. Gebruik GPT-4o, Google Veo, Wan 2.5 en Nano Banana in één dashboard. De ultieme AI-modelaggregator.`,
        feature2Title: `AI-videotools: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Meer dan generatie. Verminder bewerkingstijd met 90% met AI Video Face Swap, auto Lip Sync, Subtitle Eraser en 4K Video Upscaler.`,
        feature3Title: `Tekst naar video en afbeeldinggeneratie`,
        feature3Desc: `Zet tekstprompts om in realistische 4K-videos en afbeeldingen. Ondersteunt cinematische opnames, anime-stijlen en fotorealistische portretten met de nieuwste generatieve engines.`,
        feature4Title: `AI-karakter en lichaamsbewegingsoverdracht`,
        feature4Desc: `Laat foto\'s "dansen" met Motion Imitation (Viggle-stijl), wissel naadloos gezichten in videos, of creëer consistente AI-karakters voor je verhalen.`,
        feature5Title: `Afbeelding-naar-video & Video-naar-video`,
        feature5Desc: `Begin niet vanaf nul. Upload een foto om te animeren (Img2Vid) of restyle bestaande beelden (Vid2Vid) naar anime- of claymation-stijlen direct.`,
        feature6Title: `AI voor e-commerce en productfotografie`,
        feature6Desc: `Verwijder direct achtergronden, genereer productshowcases met AI Image Background Changer en creëer marketingmaterialen die converteren.`,
        feature7Title: 'Contextbewuste intelligente AI',
        feature7Desc:
            'WeryAI detecteert automatisch gezichten, objecten, scènes, belichting en context om nauwkeurige resultaten te leveren.',
        feature8Title: 'API en batchtools',
        feature8Desc:
            'Schaal je workflow met batchverwerkingstools of API-integratie voor creatieve automatisering op grote schaal.',

        // Sectie 3: Hoe te gebruiken
        howToUseTitle: 'Hoe genereer je AI-video en afbeeldingen in 4 stappen',
        step1Title: 'Selecteer een tool',
        step1Desc: `Kies uit Text-to-Video, Face Swap of Image Generator.`,
        step2Title: 'Voer prompt in of upload',
        step2Desc: `Typ een tekstbeschrijving of upload je foto/video-referentie.`,
        step3Title: 'Kies model',
        step3Desc: `Schakel tussen Kling, Veo of Flux om precies de stijl te krijgen die je wilt.`,
        step4Title: 'Genereer en exporteer',
        step4Desc: `Krijg resultaten in seconden. Download in HD/4K zonder complexe bewerkingsvaardigheden.`,

        // Sectie 4: FAQ
        faqTitle: 'Veelgestelde vragen over WeryAI',
        faqDesc:
            'WeryAI is ontworpen voor makers, marketeers, ontwerpers, ontwikkelaars en iedereen die ideeën snel en moeiteloos wil omzetten in hoogwaardige visuals.\nHieronder staan de kernsterktes die WeryAI tot een toonaangevend AI video- en afbeeldingcreatieplatform maken.',
        faq1Question: 'Waarom is WeryAI beter dan modellen apart gebruiken?',
        faq1Answer: `WeryAI fungeert als een aggregator. In plaats van aparte abonnementen te betalen voor Kling, Midjourney of Runway, krijg je toegang tot alle topmodellen (Kling 2.5, Flux Pro, Google Veo) in één dashboard. Het bespaart geld en stroomlijnt je workflow.`,
        faq2Question: 'Is WeryAI gratis te gebruiken?',
        faq2Answer: `Ja. We bieden genereuze dagelijkse gratis credits zodat je onze Text-to-Video, Face Swap en Image Generator-tools kunt testen. Geen creditcard nodig om te starten. Voor intensief gebruik en downloads zonder watermerk zijn er flexibele betaalde plannen beschikbaar.`,
        faq3Question: 'Kan ik Kling AI en Flux op dit platform gebruiken?',
        faq3Answer: `Absoluut. WeryAI integreert de nieuwste versies van Kling (voor realistische video), Flux (voor afbeeldingen van hoge kwaliteit) en Google Veo. We updaten onze modelbibliotheek wekelijks zodat je altijd toegang hebt tot het nieuwste.`,
        faq4Question: 'Hoe kan ik mijn videos van lage kwaliteit verbeteren?',
        faq4Answer: `Gebruik onze AI Video Upscaler. Het verwijdert automatisch ruis/vervaging en schaalt beeldmateriaal op naar 4K-resolutie. Het is perfect voor het herstellen van oude familievideos of het verbeteren van sociale mediaclips.`,
        faq5Question: 'Bezit ik de commerciële rechten op mijn creaties?',
        faq5Answer: `Als je een betaald plan hebt, ja. Je bezit volledige commerciële rechten op alle assets gegenereerd op WeryAI, waardoor ze veilig zijn voor YouTube-monetisatie, klantenwerk en marketingcampagnes.`,
        faq6Question: 'Heb ik bewerkingsvaardigheden nodig om WeryAI te gebruiken?',
        faq6Answer:
            'Geen ervaring nodig—WeryAI automatiseert complexe video- en afbeeldingbewerking zodat iedereen professionele resultaten kan creëren in seconden.',
    },
    // 印尼语
    id: {
        // Tombol
        expandMore: 'Perluas lebih banyak',
        collapse: 'Ciutkan',

        // Bagian 1: Pengenalan judul
        mainTitle: 'Platform generator video & gambar AI gratis lengkap',
        mainDesc1:
            'Akses model AI terbaik dunia di satu tempat. Buat video sinematik dengan Kling AI, Google Veo, dan Sora, ciptakan seni realistis dengan FLUX dan Wan AI, atau gunakan alat canggih seperti Face Swap dan Video Upscaler. Tanpa berpindah aplikasi—hanya kreasi murni.',
        mainDesc2:
            'Buat video dan gambar profesional secara instan dengan platform kreasi AI tercepat dan paling intuitif.',

        // Bagian 2: Mengapa memilih WeryAI
        whyChooseTitle: 'Mengapa WeryAI adalah generator konten AI terbaik?',
        whyChooseDesc:
            'WeryAI dirancang untuk kreator, pemasar, desainer, developer, dan siapa saja yang ingin mengubah ide menjadi visual berkualitas tinggi—dengan cepat dan mudah.\nBerikut adalah kekuatan inti yang menjadikan WeryAI platform pembuatan video dan gambar AI terkemuka.',

        // 8 Fitur
        feature1Title: 'Akses model AI teratas (Kling, Flux, Sora)',
        feature1Desc: `Berhenti membayar banyak langganan. Gunakan GPT-4o, Google Veo, Wan 2.5, dan Nano Banana dalam satu dasbor. Agregator model AI terbaik.`,
        feature2Title: `Alat video AI: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Lebih dari sekadar generasi. Kurangi waktu editing 90% dengan AI Video Face Swap, auto Lip Sync, Subtitle Eraser, dan 4K Video Upscaler.`,
        feature3Title: `Teks ke video dan generasi gambar`,
        feature3Desc: `Ubah prompt teks menjadi video dan gambar 4K yang realistis. Mendukung shot sinematik, gaya anime, dan potret fotorealistis dengan mesin generatif terbaru.`,
        feature4Title: `Transfer gerakan karakter dan tubuh AI`,
        feature4Desc: `Buat foto "menari" dengan Motion Imitation (gaya Viggle), tukar wajah dalam video dengan mulus, atau buat karakter AI yang konsisten untuk cerita Anda.`,
        feature5Title: `Gambar-ke-video & Video-ke-video`,
        feature5Desc: `Tidak perlu mulai dari nol. Unggah foto untuk menganimasikannya (Img2Vid) atau restyle footage yang ada (Vid2Vid) ke gaya anime atau claymation secara instan.`,
        feature6Title: `AI untuk e-commerce dan fotografi produk`,
        feature6Desc: `Hapus latar belakang secara instan, buat showcase produk dengan AI Image Background Changer, dan ciptakan aset pemasaran yang mengkonversi.`,
        feature7Title: 'AI cerdas yang sadar konteks',
        feature7Desc:
            'WeryAI secara otomatis mendeteksi wajah, objek, adegan, pencahayaan, dan konteks untuk memberikan hasil yang akurat.',
        feature8Title: 'API dan alat batch',
        feature8Desc:
            'Skalakan alur kerja Anda dengan alat pemrosesan batch atau integrasi API untuk otomatisasi kreatif volume tinggi.',

        // Bagian 3: Cara menggunakan
        howToUseTitle: 'Cara menghasilkan video dan gambar AI dalam 4 langkah',
        step1Title: 'Pilih alat',
        step1Desc: `Pilih dari Text-to-Video, Face Swap, atau Image Generator.`,
        step2Title: 'Masukkan prompt atau unggah',
        step2Desc: `Ketik deskripsi teks atau unggah referensi foto/video Anda.`,
        step3Title: 'Pilih model',
        step3Desc: `Beralih antara Kling, Veo, atau Flux untuk mendapatkan gaya yang tepat yang Anda inginkan.`,
        step4Title: 'Hasilkan dan ekspor',
        step4Desc: `Dapatkan hasil dalam hitungan detik. Unduh dalam HD/4K tanpa keterampilan editing yang rumit.`,

        // Bagian 4: FAQ
        faqTitle: 'Pertanyaan yang sering diajukan tentang WeryAI',
        faqDesc:
            'WeryAI dirancang untuk kreator, pemasar, desainer, developer, dan siapa saja yang ingin mengubah ide menjadi visual berkualitas tinggi—dengan cepat dan mudah.\nBerikut adalah kekuatan inti yang menjadikan WeryAI platform pembuatan video dan gambar AI terkemuka.',
        faq1Question: 'Mengapa WeryAI lebih baik daripada menggunakan model secara terpisah?',
        faq1Answer: `WeryAI bertindak sebagai agregator. Alih-alih membayar langganan terpisah untuk Kling, Midjourney, atau Runway, Anda mendapatkan akses ke semua model teratas (Kling 2.5, Flux Pro, Google Veo) dalam satu dasbor. Ini menghemat uang dan menyederhanakan alur kerja Anda.`,
        faq2Question: 'Apakah WeryAI gratis untuk digunakan?',
        faq2Answer: `Ya. Kami menawarkan kredit gratis harian yang melimpah sehingga Anda dapat mencoba alat Text-to-Video, Face Swap, dan Image Generator kami. Tidak perlu kartu kredit untuk memulai. Untuk penggunaan berat dan unduhan tanpa watermark, tersedia paket berbayar yang fleksibel.`,
        faq3Question: 'Bisakah saya menggunakan Kling AI dan Flux di platform ini?',
        faq3Answer: `Tentu saja. WeryAI mengintegrasikan versi terbaru Kling (untuk video realistis), Flux (untuk gambar berkualitas tinggi), dan Google Veo. Kami memperbarui perpustakaan model setiap minggu sehingga Anda selalu memiliki akses ke yang terbaru.`,
        faq4Question: 'Bagaimana cara meningkatkan video berkualitas rendah saya?',
        faq4Answer: `Gunakan AI Video Upscaler kami. Secara otomatis menghapus noise/blur dan meningkatkan footage ke resolusi 4K. Sempurna untuk memulihkan video keluarga lama atau meningkatkan klip media sosial.`,
        faq5Question: 'Apakah saya memiliki hak komersial atas kreasi saya?',
        faq5Answer: `Jika Anda menggunakan paket berbayar, ya. Anda memiliki hak komersial penuh atas semua aset yang dihasilkan di WeryAI, menjadikannya aman untuk monetisasi YouTube, pekerjaan klien, dan kampanye pemasaran.`,
        faq6Question: 'Apakah saya perlu keterampilan editing untuk menggunakan WeryAI?',
        faq6Answer:
            'Tidak perlu pengalaman—WeryAI mengotomatisasi editing video dan gambar yang kompleks sehingga siapa pun dapat membuat hasil profesional dalam hitungan detik.',
    },
    // 土耳其语
    tr: {
        // Düğmeler
        expandMore: 'Daha fazla göster',
        collapse: 'Daralt',

        // Bölüm 1: Başlık tanıtımı
        mainTitle: 'Ücretsiz hepsi bir arada AI video ve görsel oluşturma platformu',
        mainDesc1:
            'Dünyanın en iyi AI modellerine tek bir yerden erişin. Kling AI, Google Veo ve Sora ile sinematik videolar oluşturun, FLUX ve Wan AI ile gerçekçi sanat yaratın veya Face Swap ve Video Upscaler gibi gelişmiş araçları kullanın. Uygulama değiştirme yok—sadece saf yaratıcılık.',
        mainDesc2:
            'En hızlı ve en sezgisel AI oluşturma platformuyla anında profesyonel videolar ve görseller oluşturun.',

        // Bölüm 2: Neden WeryAI
        whyChooseTitle: 'WeryAI neden en iyi AI içerik oluşturucusu?',
        whyChooseDesc:
            'WeryAI, fikirleri hızlı ve zahmetsizce yüksek kaliteli görsellere dönüştürmek isteyen içerik üreticileri, pazarlamacılar, tasarımcılar, geliştiriciler ve herkes için tasarlanmıştır.\nAşağıda WeryAI\'yi lider bir AI video ve görsel oluşturma platformu yapan temel güçlü yönler yer almaktadır.',

        // 8 Özellik
        feature1Title: 'En iyi AI modellerine erişim (Kling, Flux, Sora)',
        feature1Desc: `Birden fazla abonelik için ödeme yapmayı bırakın. GPT-4o, Google Veo, Wan 2.5 ve Nano Banana\'yı tek bir panoda kullanın. Nihai AI model toplayıcısı.`,
        feature2Title: `AI video araçları: Face Swap, Lip Sync & Upscale`,
        feature2Desc: `Sadece oluşturma değil. AI Video Face Swap, otomatik Lip Sync, Subtitle Eraser ve 4K Video Upscaler ile düzenleme süresini %90 azaltın.`,
        feature3Title: `Metinden videoya ve görsel oluşturma`,
        feature3Desc: `Metin istemlerini gerçekçi 4K video ve görsellere dönüştürün. En son üretken motorlarla sinematik çekimler, anime stilleri ve fotorealistik portreler desteklenir.`,
        feature4Title: `AI karakter ve vücut hareketi aktarımı`,
        feature4Desc: `Motion Imitation (Viggle tarzı) ile fotoğrafları "dans ettirin", videolarda yüzleri sorunsuzca değiştirin veya hikayeleriniz için tutarlı AI karakterler oluşturun.`,
        feature5Title: `Görselden videoya & Videodan videoya`,
        feature5Desc: `Sıfırdan başlamayın. Bir fotoğraf yükleyerek canlandırın (Img2Vid) veya mevcut görüntüleri (Vid2Vid) anında anime veya claymation stillerine dönüştürün.`,
        feature6Title: `E-ticaret ve ürün fotoğrafçılığı için AI`,
        feature6Desc: `Arka planları anında kaldırın, AI Image Background Changer ile ürün vitrinleri oluşturun ve dönüştüren pazarlama varlıkları yaratın.`,
        feature7Title: 'Bağlam farkındalığına sahip akıllı AI',
        feature7Desc:
            'WeryAI, hassas sonuçlar sunmak için yüzleri, nesneleri, sahneleri, aydınlatmayı ve bağlamı otomatik olarak algılar.',
        feature8Title: 'API ve toplu araçlar',
        feature8Desc:
            'Yüksek hacimli yaratıcı otomasyon için toplu işleme araçları veya API entegrasyonu ile iş akışınızı ölçeklendirin.',

        // Bölüm 3: Nasıl kullanılır
        howToUseTitle: '4 adımda AI video ve görsel nasıl oluşturulur',
        step1Title: 'Bir araç seçin',
        step1Desc: `Text-to-Video, Face Swap veya Image Generator arasından seçim yapın.`,
        step2Title: 'İstem girin veya yükleyin',
        step2Desc: `Bir metin açıklaması yazın veya fotoğraf/video referansınızı yükleyin.`,
        step3Title: 'Model seçin',
        step3Desc: `İstediğiniz stili elde etmek için Kling, Veo veya Flux arasında geçiş yapın.`,
        step4Title: 'Oluşturun ve dışa aktarın',
        step4Desc: `Saniyeler içinde sonuç alın. Karmaşık düzenleme becerileri olmadan HD/4K olarak indirin.`,

        // Bölüm 4: SSS
        faqTitle: 'WeryAI hakkında sık sorulan sorular',
        faqDesc:
            'WeryAI, fikirleri hızlı ve zahmetsizce yüksek kaliteli görsellere dönüştürmek isteyen içerik üreticileri, pazarlamacılar, tasarımcılar, geliştiriciler ve herkes için tasarlanmıştır.\nAşağıda WeryAI\'yi lider bir AI video ve görsel oluşturma platformu yapan temel güçlü yönler yer almaktadır.',
        faq1Question: 'WeryAI neden modelleri ayrı ayrı kullanmaktan daha iyi?',
        faq1Answer: `WeryAI bir toplayıcı olarak çalışır. Kling, Midjourney veya Runway için ayrı abonelikler ödemek yerine, tüm üst düzey modellere (Kling 2.5, Flux Pro, Google Veo) tek bir panodan erişebilirsiniz. Bu hem paradan tasarruf sağlar hem de iş akışınızı kolaylaştırır.`,
        faq2Question: 'WeryAI ücretsiz mi?',
        faq2Answer: `Evet. Text-to-Video, Face Swap ve Image Generator araçlarımızı denemeniz için cömert günlük ücretsiz krediler sunuyoruz. Başlamak için kredi kartı gerekmez. Yoğun kullanım ve filigranlı olmayan indirmeler için esnek ücretli planlar mevcuttur.`,
        faq3Question: 'Bu platformda Kling AI ve Flux kullanabilir miyim?',
        faq3Answer: `Kesinlikle. WeryAI, Kling\'in (gerçekçi video için), Flux\'un (yüksek kaliteli görseller için) ve Google Veo\'nun en son sürümlerini entegre eder. Model kütüphanemizi her hafta güncelliyoruz, böylece her zaman en yeniye erişebilirsiniz.`,
        faq4Question: 'Düşük kaliteli videolarımı nasıl iyileştirebilirim?',
        faq4Answer: `AI Video Upscaler\'ımızı kullanın. Otomatik olarak gürültüyü/bulanıklığı kaldırır ve görüntüleri 4K çözünürlüğe yükseltir. Eski aile videolarını geri yüklemek veya sosyal medya kliplerini iyileştirmek için mükemmeldir.`,
        faq5Question: 'Oluşturduklarımın ticari haklarına sahip miyim?',
        faq5Answer: `Ücretli bir plandaysanız, evet. WeryAI\'de oluşturulan tüm varlıklar üzerinde tam ticari haklara sahipsiniz, bu da onları YouTube para kazanma, müşteri işleri ve pazarlama kampanyaları için güvenli kılar.`,
        faq6Question: 'WeryAI kullanmak için düzenleme becerilerine ihtiyacım var mı?',
        faq6Answer:
            'Hiçbir deneyim gerekli değil—WeryAI karmaşık video ve görsel düzenlemeyi otomatikleştirir, böylece herkes saniyeler içinde profesyonel sonuçlar oluşturabilir.',
    },
}
